<template>
	<div @click="close_selection += 1">
		<v-alert class="mt-4" type="error" dense v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<v-row class="ma-0 px-4 py-1 background-color" justify="space-between" align="center">
			<v-row class="ma-0">
				<MedisPrint :color="color" width="20" height="20" class="mr-2"/>
				<span class="title-sytle selector-item-style">Bookings</span>
			</v-row>
			<v-btn icon @click="$emit('close', false)">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-row>
		<v-row class="ma-0 px-1 pt-0 background-color">
			<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12: 4" class="py-0">
				<div class="font-normal-style font-header-style" style="line-height: 20px;">Phase</div>
				<v-select
					v-model="phase_local"
					:color="color"
					:menu-props="{ bottom: true, offsetY: true}"
					:loading="phase_loading"
					:disabled="!isEditableRate || !ableEdit || !bookingEdit"
					:items="phase_items"
					item-value="id"
					item-text="desc"
					item-color="media"
					background-color="#FAFAFA"
					outlined
					dense
					hide-details
					return-object
				>
				</v-select>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12: 4" class="py-0">
				<div class="font-normal-style font-header-style" style="line-height: 20px;">Supplier</div>
				<v-autocomplete
					v-model="supplier_local"
					:color="color"
					:menu-props="{ bottom: true, offsetY: true}"
					:loading="supplier_loading"
					:disabled="!isEditableRate || !ableEdit || !bookingEdit"
					:items="supplier_items"
					:autofocus="mediaId === 0"
					:error="isSupplierError"
					item-text="desc"
					item-color="media"
					background-color="#FAFAFA"
					outlined
					dense
					hide-details
					return-object
					clearable
					@change="onSupplierChange()"
				>
				</v-autocomplete>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12: 4" class="py-0">
				<div class="font-normal-style font-header-style" style="line-height: 20px;">Kind</div>
				<KindTreeSelection
					:color="color"
					:bgColor="'#FAFAFA'"
					:kindParams="kindParams"
					:kindSelected="kind_local"
					:closeSelection="close_selection"
					:error="isKindError"
					:disabled="!isEditableRate || !ableEdit || !bookingEdit"
					@kind-selected="onKindChange($event)"
				/>
				<div class="optional-text">required</div>
			</v-col>
		</v-row>
		<v-row class="ma-0 px-1 pt-0 pb-3 background-color">
			<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12: 4" class="py-0">
				<div class="font-normal-style font-header-style" style="line-height: 20px;">Description</div>
				<v-text-field
					v-model="description"
					:color="color"
					:error="isDescError"
					:disabled="!ableEdit || !bookingEdit"
					background-color="#FAFAFA"
					outlined
					dense
					hide-details
				></v-text-field>
				<div class="optional-text">required</div>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12: 4" class="py-0">
				<div class="font-normal-style font-header-style" style="line-height: 20px;">Target</div>
				<v-text-field
					v-model="target"
					:color="color"
					:disabled="!ableEdit || !bookingEdit"
					background-color="#FAFAFA"
					outlined
					dense
					hide-details
				></v-text-field>
				<div class="optional-text">optional</div>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12: 4" class="py-0">
				<div class="font-normal-style font-header-style" style="line-height: 20px;">Notes</div>
				<v-text-field
					v-model="notes"
					:color="color"
					:disabled="!ableEdit || !bookingEdit"
					background-color="#FAFAFA"
					outlined
					dense
					hide-details
				></v-text-field>
				<div class="optional-text">optional</div>
			</v-col>
		</v-row>
		<div :style="{ height: is_fixed ? `${button_height}px` : '0px' }"></div>
		<v-row
			ref="toolbar"
			class="ma-0 px-3 py-2"
			:class="is_fixed ? 'fixedToolbar':''"
			dense 
		>
			<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12: 6">
				<v-row class="ma-0" justify="start">
					<v-btn v-if="mediaId !== 0" class="text-style text-capitalize px-3 mr-3" :color="'#FAFAFA'" @click="onRefresh()">
						<v-icon size="20" :color="'#82899B'" class="mr-2">mdi-refresh</v-icon>
						<span  style="color: #192A3E">Refresh</span>
					</v-btn>
					<v-select
						class="select-field"
						v-model="status"
						:items="status_items"
						:color="color"
						:item-color="color"
						:disabled="mediaId === 0"
						:menu-props="{ bottom: true, offsetY: true, closeOnClick: true}"
						background-color="#FAFAFA"
						append-icon="mdi-chevron-down"
						solo
						dense
						hide-details
						multiple
						return-object
						@change="onStatusFilte($event)"
					>
						<template v-slot:selection="{ index }">
							<div v-if="index === 0" style="width: 99%">
								<div class="font-over-long">
									<span class="text-style text-nomal-color">Status:&nbsp;</span>
									<span v-if="status.length === 5" class="text-style" style="font-weight: 500" :style="mediaId === 0 ? 'color: rgba(25, 42, 62, 0.5)' : 'color: #192A3E'" >All</span>
									<span v-else class="text-style" style="font-weight: 500; color: #192A3E">{{ (status.map(s => { return s.text })).join() }}</span>
								</div>
							</div>
						</template>
					</v-select>
				</v-row>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12: 6" :align="!$vuetify.breakpoint.mdAndDown ? 'end':''">
				<v-btn class="text-capitalize mr-2" elevation="1" :color="'#FAFAFA'" @click="$emit('close', false)">
					Cancel
				</v-btn>
				<v-btn v-if="mediaId === 0" :disabled="!isActive || !ableEdit || !bookingEdit" class="white--text text-capitalize" elevation="1" :color="color" @click="onCreateMedia()">
					<span>Create Bookings</span>
				</v-btn>
				<v-btn v-if="mediaId !== 0" :disabled="!isActive || !ableEdit || !bookingEdit" class="white--text text-capitalize" elevation="1" :color="color" @click="onSaveMedia()">
					<span>Save changes</span>
				</v-btn>
			</v-col>
		</v-row>
		<ProgressLinear v-if="loading" class="mx-0 mt-2 mb-4"/>
		<template v-else>
			<v-data-table
				:headers="headers"
				:items="booking_list"
				:items-per-page="-1"
				:item-class="getRowClass"
				item-key="index"
				hide-default-header
				hide-default-footer
			>
				<template v-slot:top>
					<div style="border-bottom: 1px solid rgba(25, 42, 62, 0.1)">
						<v-row class="mx-3 my-0">
							<div class="my-3 mr-4">
								<v-row class="ma-0 font-bold-style selector-item-style" style="line-height: 24px;" dense>Cost Currency</v-row>
								<v-row class="ma-0">
									<v-select
										v-model="cost_currency"
										class="select-exchange"
										style="max-width: 140px;"
										:color="color"
										:menu-props="{ bottom: true, offsetY: true}"
										:loading="currency_loading"
										:disabled="!isEditableRate || !ableEdit || !bookingEdit"
										:items="currency_items"
										item-value="id"
										item-text="code"
										item-color="media"
										background-color="#FAFAFA"
										outlined
										dense
										hide-details
										return-object
										height="30"
										@change="getListExrates($event, true)"
									>
									</v-select>
									<v-text-field
										class="mx-2 select-exchange font-normal-style font-header-style"
										style="max-width: 140px"
										:value="cost_rate.rate"
										:color="color"
										:disabled="cost_currency && system_currency && cost_currency.id === system_currency.id"
										outlined
										dense
										hide-details
										height="30"
										@change="rate_confirm_select = false; onRateChange($event, true)"
									>
									</v-text-field>
									<v-select
										class="select-exchange"
										style="max-width: 160px;"
										:value="cost_rate"
										:color="color"
										:menu-props="{ bottom: true, offsetY: true}"
										:loading="cost_rate_loading"
										:disabled="cost_currency && system_currency && cost_currency.id === system_currency.id"
										:items="cost_rate_list"
										item-value="id"
										item-text="rate"
										item-color="media"
										background-color="#FAFAFA"
										placeholder="Select rate"
										outlined
										dense
										hide-details
										return-object
										height="30"
										@change="rate_confirm_select = true; onRateChange($event, true)"
									>
										<template v-slot:item="{ item }">
											<v-row
												class="ma-0 hover-text font-normal-style"
												:class="cost_rate.id === item.id ? 'selector-item-style':''"
												style="font-size: 14px;min-width: 200px;" 
												justify="space-between" 
												align="center"
											>
												<div>{{ item.date }}</div>
												<div>{{ item.rate }}</div>
											</v-row>
										</template>
										<template v-slot:selection="{ item, index }">
											<div v-if="index === 0">Select rate</div>
										</template>
									</v-select>
								</v-row>
							</div>
							<div class="my-3 mr-4">
								<v-row class="ma-0 font-bold-style selector-item-style" style="line-height: 24px;" dense>Schedule Currency</v-row>
								<v-row class="ma-0">
									<v-select
										class="select-exchange"
										style="max-width: 140px;"
										v-model="schedule_currency"
										:color="color"
										:menu-props="{ bottom: true, offsetY: true}"
										:loading="currency_loading"
										:disabled="!isEditableRate || !ableEdit || !bookingEdit"
										:items="currency_items"
										item-value="id"
										item-text="code"
										item-color="media"
										background-color="#FAFAFA"
										outlined
										dense
										hide-details
										return-object
										height="30"
										@change="getListExrates($event, false)"
									>
									</v-select>
									<v-text-field
										class="mx-2 select-exchange font-normal-style font-header-style"
										style="max-width: 140px"
										:value="schedule_rate.rate"
										:color="color"
										:disabled="schedule_currency && system_currency && schedule_currency.id === system_currency.id"
										outlined
										dense
										hide-details
										height="30"
										@change="rate_confirm_select = false; onRateChange($event, false)"
									>
									</v-text-field>
									<v-select
										class="select-exchange"
										style="max-width: 160px;"
										:value="schedule_rate"
										:color="color"
										:menu-props="{ bottom: true, offsetY: true}"
										:loading="schedule_rate_loading"
										:disabled="schedule_currency && system_currency && schedule_currency.id === system_currency.id"
										:items="schedule_rate_list"
										item-value="id"
										item-text="rate"
										item-color="media"
										background-color="#FAFAFA"
										placeholder="Select rate"
										outlined
										dense
										hide-details
										return-object
										height="30"
										@change="rate_confirm_select = true; onRateChange($event, false)"
									>
										<template v-slot:item="{ item }">
											<v-row
												class="ma-0 hover-text font-normal-style"
												:class="schedule_rate.id === item.id ? 'selector-item-style':''"
												style="font-size: 14px;min-width: 200px;" 
												justify="space-between" 
												align="center"
											>
												<div>{{ item.date }}</div>
												<div>{{ item.rate }}</div>
											</v-row>
										</template>
										<template v-slot:selection="{ item, index }">
											<div v-if="index === 0">Select rate</div>
										</template>
									</v-select>
								</v-row>
							</div>
							<div class="my-3 mr-4">
								<v-row class="ma-0 font-bold-style selector-item-style" style="line-height: 24px;" dense>Exchange rate margin</v-row>
								<v-row class="ma-0" align="center">
									<v-text-field
										class="select-exchange font-normal-style font-header-style"
										style="max-width: 146px; text-align: end;align-items: center"
										:value="exchange_rate"
										:color="color"
										:disabled="!ableEdit || !bookingEdit"
										outlined
										dense
										hide-details
										height="28"
										@change="exchange_rate = Number($event).toFixed(2)"
									>
										<template v-slot:prepend>
											<v-icon small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
										</template>
									</v-text-field>
								</v-row>
							</div>
						</v-row>
					</div>
				</template>
				<template v-slot:header="{ props: { headers } }">
					<thead>
						<tr>
							<th v-for="header in headers" :key="header.value" :style="header.value === 'status' ? 'border-right: thin solid rgba(0, 0, 0, 0.12)': ''">
								<v-row class="ma-0 px-3" :style="`width: ${header.width}px`" :class="!left_header.includes(header.value) && header.value !== 'deadline' ? 'header-background-color':''" v-for="(header_item, index) in header.text" :key="`${index}_${header.value}`">
									<span class="font-bold-style font-header-style">{{ header_item }}&nbsp;</span>
								</v-row>
							</th>
						</tr>
					</thead>
				</template>
				<template v-slot:body="{ items, headers }">
					<tbody>
						<template v-if="items.length === 0">
							<tr>
								<td :colspan="headers.length">
									<v-row class="font-normal-style font-header-style ma-0 px-3" justify="center" style="line-height: 24px">
										<div>&nbsp;&nbsp;</div>
									</v-row>
								</td>
							</tr>
						</template>
						<template v-else>
							<tr v-for="(item_obj, index) in items" :key="index">
								<td v-for="(item, key) in filterItem(item_obj)" :key="key" :style="key === 'status' ? 'border-right: thin solid rgba(0, 0, 0, 0.12)': ''">
									<div v-if="key === 'units'" style="width: 80px">
										<v-row class="ma-0 px-2" style="flex-wrap: nowrap;" align="start">
											<v-text-field
												v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
												class="field-in-cell font-normal-style font-header-style"
												style="max-width: 100px; text-align: end;align-items: end"
												v-model="item_obj.units"
												:color="color"
												type="number"
												outlined
												dense
												hide-details
												height="40"
												min="1"
												oninput="if(this.value < 1) this.value = 1"
												@input="onChangeUnit($event, item_obj.index)"
											>
											</v-text-field>
											<v-col v-if="!ableEdit || !bookingEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po" cols="12">
												<span>&nbsp;&nbsp;{{ item_obj.units }}</span>
											</v-col>
										</v-row>
									</div>
									<div v-if="key === 'date'" style="width: 280px">
										<v-row class="ma-0 px-2" style="flex-wrap: nowrap;" align="center">
											<DateMulti
												v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
												style="width: 280px"
												class="date-in-cell"
												:color="color"
												:background="'transparent'"
												:suggestionText="''"
												:hideDetails="true"
												:dateStartInit="item_obj.date[0]"
												:dateEndInit="item_obj.date[1]"
												@dateRange="onChangeDate($event, item_obj.index)"
											/>
											<v-row v-else class="ma-0 px-3"  style="flex-wrap: nowrap;" align="center">
												<div style="width: 20px; height: 20px">
													<Calendar :color="'rgba(25, 42, 62, 0.5)'" width="20" height="20"/>
												</div>
												<div class="ml-2 font-normal-style font-header-style" style="min-width: 100px;text-align: start;line-height: 16px">{{ getDateText(item_obj.date) }}</div>
											</v-row>
										</v-row>
									</div>
									<div v-if="key === 'status'" style="width: 200px">
										<v-row class="ma-0 px-2" style="flex-wrap: nowrap;" align="center">
											<v-chip v-if="mediaId === 0 || !bookingEdit|| !ableStatus || item_obj.status.key === 'reversed' || item_obj.status.key === 'reversal' || item_obj.status.key === 'unapproved' || item_obj.status.key === 'test_invoice' || item_obj.status.key === 'note' || ((item_obj.status.key === 'booked' || item_obj.status.key === 'planned') && item_obj.has_po) || (item_obj.status.key === 'planned' && item_obj.id === 0) || (item_obj.status_original_id === 4 && (!ableInv  || (ableInv && item_obj.has_cinv)))"
												class="text-capitalize white--text mr-1"
												style="min-width: 140px;"
												label 
												:color="item_obj.status.color">
												{{ item_obj.status.text }}
											</v-chip>
											<v-select
												v-else
												class="select-in-cell text-capitalize mr-1"
												style="max-width: 136px;"
												v-model="item_obj.status"
												color="#FFFFFF"
												:background-color="item_obj.status.color"
												:menu-props="{ bottom: true, offsetY: true}"
												:items="filterStatus(item_obj.status_original_id)"
												item-color="media"
												solo
												flat
												dense
												hide-details
												return-object
												@change="onStatusChange($event, item_obj)"
											>
												<template v-slot:append="">
													<v-icon color="#FFFFFF">mdi-chevron-down</v-icon>
												</template>
												<template v-slot:selection="{ item }">
													<span class="white--text">{{ item.text }}</span>
												</template>
												<template v-slot:item="{item, on}">
													<v-list-item v-on="on" dense>
														<div v-if="item.last" :class="item.last && item_obj.status.key !== item.key ? 'pt-2':'' ">
															<v-badge
																:color="item.color"
																left
																inline
															>
																<span :class="item_obj.status.key === item.key ? 'font-bold-style selector-item-style':'font-normal-style font-header-style'">{{ item.text }}</span>
															</v-badge>
															<v-alert
																class="mt-0 mb-0"
																style="width: 240px; line-height: 20px; padding: 0 0 0 2px;"
																dense
																text
																type="warning"
																icon="mdi-alert-circle"
															>
																<span class="font-normal-style font-header-style">Note: Change of status here won’t create a PO or invoice. </span>	
															</v-alert>
														</div>
														<div v-else>
															<v-badge
																:color="item.color"
																left
																inline
															>
																<span :class="item_obj.status.key === item.key ? 'font-bold-style selector-item-style':'font-normal-style font-header-style'">{{ item.text }}</span>
															</v-badge>
														</div>
													</v-list-item>
												</template>
											</v-select>
											<v-tooltip v-if="item_obj.status.delete && item_obj.status.value.includes(planned_value) && !item_obj.has_po" top max-width="300" color="#192A3E">
												<template v-slot:activator="{ on, attrs }">
													<v-btn class="disable-btn" small icon v-bind="attrs" v-on="on" :disabled="!ableDelete || !bookingEdit"  @click.stop="onDeleteBooking(item_obj)">
														<Delete
															class="ml-2 mt-1"
															:color="ableDelete ? 'rgba(25, 42, 62, 0.6)' :'rgba(0, 0, 0, 0.26)'" 
															width="20" 
															height="20"
														/>	
													</v-btn>
												</template>
												<span v-if="ableDelete">Delete booking</span>
												<span v-else>Insufficient privileges to use this function. Please contact your system administrator if this is incorrect.</span>
											</v-tooltip>
											<v-tooltip v-if="!item_obj.status.delete" top color="#192A3E">
												<template v-slot:activator="{ on, attrs }">
													<v-btn small icon v-bind="attrs" v-on="on" :disabled="!ableEdit || !bookingEdit" @click.stop="onReverseBooking(item_obj)">
														<v-icon :color="'rgba(25, 42, 62, 0.6)'" small class="ml-1">mdi-backspace-reverse-outline</v-icon>
													</v-btn>
												</template>
												<span>Reverse booking</span>
											</v-tooltip>
											<v-tooltip v-if="item_obj.status.key !== 'reversed' && item_obj.status.key !== 'reversal'" top color="#192A3E">
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon small v-bind="attrs" v-on="on" :disabled="!ableCreateTask || !bookingEdit" @click.stop="onCreateTask(item_obj)">
														<v-icon :color="'rgba(25, 42, 62, 0.6)'" :size="20">mdi-plus</v-icon>
													</v-btn>
												</template>
												<span>Create Task</span>
											</v-tooltip>
										</v-row>
									</div>
									<div v-if="key === 'cost'" style="width: 140px">
										<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 my-1 pl-4 pr-2" style="flex-wrap: nowrap; height: 24px" v-for="(cost, index) in item_obj.cost" :key="`${index}_currency`">
											<span class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ cost }}&nbsp;</span>
										</v-row>
									</div>
									<div v-if="key === 'supplier'" style="width: 160px">
										<v-row justify="space-between" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(supplier, index) in item_obj.supplier" :key="`${index}_supplier`">
											<span v-if="item_obj.cost_currency" class="selector-item-style mr-1">{{ item_obj.cost_currency.code }}&nbsp;</span>
											<v-text-field
												v-if="index === 0 && item_obj.status.value.includes(planned_value) && !item_obj.has_po && bookingEdit"
												class="field-in-cell font-normal-style"
												:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
												style="text-align: end;align-items: end; color:blue"
												:value="numberFormat(supplier)"
												:color="color"
												:disabled="!ableEdit"
												outlined
												dense
												hide-details
												height="24"
												@change="onChangeSupplier($event, item_obj.index)"
											>
											</v-text-field>
											<span v-if="index === 0 && (!item_obj.status.value.includes(planned_value) || item_obj.has_po || !bookingEdit)" :class="item_obj.status.value.includes(reversal_value)? 'reversal-text-color':'font-header-style'" style="font-weight: 400;">{{ numberFormat(supplier) }}&nbsp;</span>
											<span v-if="index === 1" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'" style="font-weight: 400;">{{ numberFormat(supplier) }}&nbsp;</span>
										</v-row>
									</div>
									<div v-if="key === 'commission'" style="width: 140px">
										<v-row class="font-normal-style font-header-style  mx-0 my-1 px-1" style="flex-wrap: nowrap; line-height: 24px" v-for="(commission, index) in item_obj.commission" :key="`${index}_commission`">
											<v-text-field
												v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
												class="field-in-cell font-normal-style"
												:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
												style="text-align: end;align-items: end"
												:value="numberFormat(commission)"
												:color="color"
												outlined
												dense
												hide-details
												height="24"
												@change="onChangeCommission($event, item_obj.index, index)"
											>
												<template v-slot:prepend>
													<v-icon v-if="index === 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-currency-usd</v-icon>
													<v-icon v-if="index === 1" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
												</template>
											</v-text-field>
											<v-row v-if="!ableEdit || !bookingEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po" class="ma-0 pr-3" justify="space-between">
												<v-icon v-if="index === 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-currency-usd</v-icon>
												<v-icon v-if="index === 1" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
												<div :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ numberFormat(commission) }}&nbsp;</div>
											</v-row>
										</v-row>
									</div>
									<div v-if="key === 'schedule'" style="width: 140px">
										<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 my-1 pl-4 pr-2" style="flex-wrap: nowrap; height: 24px" v-for="(schedule, index) in item_obj.schedule" :key="`${index}_schedule`">
											<span class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ schedule }}&nbsp;</span>
										</v-row>
									</div>
									<div v-if="key === 'net'" style="width: 160px">
										<v-row justify="space-between" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(net, index) in item_obj.net" :key="`${index}_net`">
											<span v-if="item_obj.schedule_currency" class="selector-item-style mr-1">{{ item_obj.schedule_currency.code }}&nbsp;</span>
											<v-text-field
												v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
												class="field-in-cell font-normal-style"
												:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
												style="text-align: end;align-items: end"
												:value="numberFormat(net)"
												:color="color"
												outlined
												dense
												hide-details
												height="24"
												@change="onChangeNet($event, item_obj.index)"
											>
											</v-text-field>
											<v-text-field
												v-if="!ableEdit || !bookingEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po"
												class="field-in-cell font-normal-style pr-1"
												:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
												style="text-align: end;align-items: end"
												:value="numberFormat(net)"
												:color="color"
												background-color="transparent"
												filled
												rounded
												disabled
												dense
												hide-details
												height="24"
											>
											</v-text-field>
										</v-row>
									</div>
									<div v-if="key === 'foc'" style="width: 56px">
										<v-row justify="center">
											<v-checkbox
												class="mt-0 pt-0"
												v-model="item_obj.foc"
												:color="color"
												:disabled="!tickableFOC(item_obj) || !ableEdit || !bookingEdit"
												hide-details
												dense
												@change="onChangeFOC($event, item_obj.index)"
											></v-checkbox>
										</v-row>
									</div>
									<div v-if="key === 'mode'" style="width: 160px">
										<v-row justify="center" class="px-2">
											<v-select
												class="select-in-cell"
												:value="item_obj.mode"
												:items="mode_items"
												:color="color"
												:disabled="item_obj.foc === true || !item_obj.status.value.includes(planned_value) || item_obj.has_po  || !ableEdit || !bookingEdit"
												item-color="media"
												:menu-props="{ bottom: true, offsetY: true}"
												background-color="transparent"
												append-icon="mdi-chevron-down"
												dense
												hide-details
												solo
												flat
												return-object
												@change="onChangeMode($event, item_obj.index)"
											>
												<template v-slot:selection="{ item, disabled }">
													<span class="font-normal-style font-header-style" style="line-height: 24px;" :style="disabled ? 'color:rgba(0, 0, 0, 0.38)':''">{{ item.text }}</span>
												</template>
											</v-select>
										</v-row>
									</div>
									<div v-if="key === 'markup'" style="width: 160px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 px-1" style="flex-wrap: nowrap; line-height: 24px" v-for="(markup, index) in item_obj.markup" :key="`${index}_markup`">
											<v-text-field
												v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
												class="field-in-cell font-normal-style"
												:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
												style="text-align: end;align-items: end"
												:value="numberFormat(markup)"
												:color="color"
												:disabled="item_obj.mode.value === mode_items[1].value || item_obj.foc === true"
												outlined
												dense
												hide-details
												height="24"
												@change="onChangeMarkup($event, item_obj.index, index)"
											>
												<template v-slot:prepend>
													<v-icon v-if="index === 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-currency-usd</v-icon>
													<v-icon v-if="index === 1" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
												</template>
											</v-text-field>
											<v-text-field
												v-if="!ableEdit || !bookingEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po"
												class="field-in-cell font-normal-style pr-1"
												:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
												style="text-align: end;align-items: end"
												:value="numberFormat(markup)"
												:color="color"
												disabled
												background-color="transparent"
												filled
												rounded
												dense
												hide-details
												height="24"
											>
												<template v-slot:prepend>
													<v-icon v-if="index === 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-currency-usd</v-icon>
													<v-icon v-if="index === 1" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
												</template>
											</v-text-field>
										</v-row>
									</div>
									<div v-if="key === 'bill'" style="width: 160px">
										<v-row justify="space-between" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(bill, index) in item_obj.bill" :key="`${index}_bill`">
											<span v-if="item_obj.schedule_currency" class="selector-item-style mr-1">{{ item_obj.schedule_currency.code }}&nbsp;</span>
											<v-text-field
												v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
												class="field-in-cell font-normal-style"
												:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
												style="text-align: end;align-items: end"
												:value="numberFormat(bill)"
												:color="color"
												:disabled="item_obj.mode.value === mode_items[1].value || item_obj.foc === true"
												outlined
												dense
												hide-details
												height="24"
												@change="onChangeBill($event, item_obj.index)"
											>
											</v-text-field>
											<v-text-field
												v-if="!ableEdit || !bookingEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po"
												class="field-in-cell font-normal-style pr-1"
												:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
												style="text-align: end;align-items: end"
												:value="numberFormat(bill)"
												:color="color"
												disabled
												background-color="transparent"
												filled
												rounded
												dense
												hide-details
												height="24"
											>
											</v-text-field>
										</v-row>
									</div>
									<div v-if="key === 'voucher'" style="width: 56px">
										<v-row justify="center">
											<v-checkbox
												class="mt-0 pt-0"
												v-model="item_obj.voucher"
												:color="color"
												:disabled="!tickableVouch(item_obj) || !ableEdit || !bookingEdit"
												hide-details
												dense
											></v-checkbox>
										</v-row>
									</div>
									<div v-if="key === 'nobill'" style="width: 56px">
										<v-row justify="center">
											<v-checkbox
												class="mt-0 pt-0"
												v-model="item_obj.nobill"
												:color="color"
												:disabled="!tickableDoNoBill(item_obj) || !ableEdit || !bookingEdit"
												hide-details
												dense
											></v-checkbox>
										</v-row>
									</div>
									<div v-if="key === 'revenue'" style="width: 140px">
										<v-row class="font-normal-style font-header-style  mx-0 my-1 px-1" style="flex-wrap: nowrap; line-height: 24px" v-for="(revenue, index) in item_obj.revenue" :key="`${index}_revenue`">
											<v-text-field
												v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
												class="field-in-cell font-normal-style"
												:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
												style="text-align: end;align-items: end"
												:value="numberFormat(revenue)"
												:color="color"
												outlined
												dense
												hide-details
												disabled
												height="24"
											>
												<template v-slot:prepend>
													<v-icon small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
												</template>
											</v-text-field>
											<v-text-field
												v-if="!ableEdit || !bookingEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po"
												class="field-in-cell font-normal-style pr-1"
												:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
												style="text-align: end;align-items: end"
												:value="numberFormat(revenue)"
												:color="color"
												background-color="transparent"
												filled
												rounded
												dense
												hide-details
												disabled
												height="24"
											>
												<template v-slot:prepend>
													<v-icon small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
												</template>
											</v-text-field>
										</v-row>
									</div>
									<div v-if="key === 'deadline'" style="width: 180px">
										<v-row class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap;" align="center" v-for="(deadline, index) in item_obj.deadline" :key="`${index}_deadline`">
											<DatePicker
												v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
												style="width: 180px"
												class="date-in-cell"
												:color="color"
												:isOutlined="true"
												:isIcon="true"
												:background="'transparent'"
												:suggestionText="''"
												:persistentHint="false"
												:nudgeLeft="180"
												:dateInit="deadline"
												@date="onChangeDeadLineDate($event, item_obj.index)"
											/>
											<v-row v-else class="ma-0 px-3"  style="flex-wrap: nowrap;" align="center">
												<div style="width: 20px; height: 20px">
													<Calendar :color="'rgba(25, 42, 62, 0.5)'" width="20" height="20"/>
												</div>
												<div class="ml-2 font-normal-style font-header-style" style="min-width: 100px;text-align: start;line-height: 16px">{{ getDateText(item_obj.date) }}</div>
											</v-row>
										</v-row>
									</div>
								</td>
							</tr>
							<tr style="height: 48px; background-color: #D0D0D5;">
								<td colspan="3" style="border-right: thin solid rgba(0, 0, 0, 0.12)">
									<v-row class="ma-0 pr-4 font-bold-style font-header-style" justify="end">Total</v-row>
								</td>
								<td v-for="(item, key) in totalValue" :key="key">
									<span v-if="item.length === 0">{{ item }}&nbsp;</span>
									<v-row v-if="item.length !== 0" class="ma-0 pl-2 pr-5" justify="space-between" align="center">
										<div class="font-bold-style selector-item-style">{{ (item.split(link_icon))[0] }}</div>
										<div class="font-bold-style font-header-style">{{ (item.split(link_icon))[1] }}</div>
									</v-row>
								</td>
							</tr>
						</template>
					</tbody>
				</template>
			</v-data-table>
			<v-row class="ma-0 px-4 py-1 background-color" align="center">
				<v-btn :disabled="!supplier_local || !ableEdit || !bookingEdit"  class="white--text text-capitalize px-2" elevation="2" :color="'#FAFAFA'" @click="onAddBooking()">
					<v-icon :color="'rgba(25, 42, 62, 0.7)'">mdi-plus</v-icon>
					<span class="text-style " :class="supplier_local && ableEdit ? 'text-nomal-color':'text-nomal-disable-color'" style="font-weight: 500">Add Booking</span>
				</v-btn>
			</v-row>
		</template>
		<v-row v-if="mediaId !== 0 && radio_list.length !== 0" class="ma-0 px-4 py-4 background-color" justify="start" align="center">
			<v-row class="ma-0" align="center" style="width:120px">
				<Radio :color="'rgba(25, 42, 62, 0.7)'" width="20" height="20" class="mb-1 mr-2"/>
				<span class="title-sytle text-nomal-color">Radio Holdings</span>
			</v-row>
		</v-row>
		<RadioTable
			v-if="mediaId !== 0 && radio_list_original.length !== 0"
			:color="color"
			:mediaId="mediaId"
			:supplier="supplier_local"
			:kind="kind_local"
			:exchangeRate="exchange_rate"
			:costRate="cost_rate"
			:scheduleRate="schedule_rate"
			:costCurrency="cost_currency"
			:scheduleCurrency="schedule_currency"
			:markupPerc="markup_perc"
			:rebatePerc="rebate_perc"
			:ableEdit="ableRadioEdit"
			:ableDelete="ableDelete"
			:ableStatus="ableStatus"
			:ableInv="ableInv"
			:bookingEdit="bookingEdit"
			:radioList="radio_list"
			@radio="radio_table_list = $event"
		/>
		<v-row class="ma-0 px-4 py-1 background-color" align="center">
			<div style="height: 84px;">&nbsp;&nbsp;</div>
		</v-row>
		<RateConfirmDialog
			v-if="rate_confirm_visible"
			:visible="rate_confirm_visible" 
			:color="'info'"
			:content="rate_confirm_select ? `Do you want to update planned bookings with exchange rate #${rate_confirm.rate} for the selected date ${rate_confirm.rate}?` :`Do you want to update planned bookings with this rate?`"
			:cancel="'No'"
			:ok="'Yes'"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="onConfirmRate(false)"
			@ok="onConfirmRate(true)"
		/>
		<v-dialog
			v-if="task_visible"
			v-model="task_visible"
			persistent
			:max-width="700"
		>
			<div class="dialog-container pb-3">
				<div class="top-line"></div>
				<div class="pt-3 px-6 task-title">
					<div class="title-text">Create&nbsp;&nbsp;Task</div>
					<v-icon @click.stop="task_visible = false">mdi-close</v-icon>
				</div>
				<div class="event-btn pt-3 px-6">
					<v-btn depressed class="text-capitalize mr-3" :color="task_color">
						<span class="button-text button-text-current">Task</span>
					</v-btn>
				</div>
				<NewTask
					:color="task_color"
					:joid="jobId"
					:jpid="phase_local.id"
					:taskName="description"
					:taskKind="kind_local"
					:taskAmount="task_amount"
					:taskDate="task_date"
					@close="task_visible = false"
				/>
			</div>
			
		</v-dialog>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import DateMulti from "@/components/date/date_multi.vue";
import DatePicker from "@/components/date/date_picker.vue";
import KindTreeSelection from "@/components/kinds/kind_tree_selection";
import Calendar from "@/components/icons/calendar.vue";
import RadioTable from "@/views/desktop/media/media_planning_radio_table.vue";
import NewTask from "@/views/tasks/new_task.vue";
import RateConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";

import MedisPrint from "@/components/icons/medis_print.vue";
import Radio from "@/components/icons/radio.vue";
import Delete from "@/components/icons/delete_outline.vue";

import moment from 'moment';
import Decimal from 'decimal.js';

const Planned_Color = '#8C7503';
const Unapproved_Color = '#D5A39B';
const Booked_Color = '#C35643';
const Test_Invoice_Color = '#9DB475';
const Invoiced_Color = '#547F0A';
const Credit_Note_Color = '#2C4108';
const Reversal_Color = '#A79C9C';
const Reversed_Color = '#726A6A';


const Status_Items = [
	{ text: 'Planned', key: 'planned', value: [1], color: Planned_Color, delete: true, last: false },
	{ text: 'Booked', key: 'booked', value: [2], color: Booked_Color, delete: false, last: false },
	{ text: 'Test Invoice', key: 'test_invoice', value: [3], color: Test_Invoice_Color, delete: false, last: false },
	{ text: 'Invoiced', key: 'invoiced', value: [4], color: Invoiced_Color, delete: false, last: false },
	{ text: 'Test Credit Note', key: 'note', value: [5], color: Credit_Note_Color, delete: false, last: false },
	{ text: 'Unapproved PO', key: 'unapproved', value: [6], color: Unapproved_Color, delete: false, last: false },
	{ text: 'Reversed', key: 'reversed', value: [100], color: Reversed_Color, delete: true, last: false },
	{ text: 'Reversal', key: 'reversal', value: [101], color: Reversal_Color, delete: true, last: false },
];

const Reversed_Value = 100;
const Reversal_Value = 101;
const Planned_Value = 1;
const Unapproved_Value = 6;

const Mode_Items = [
	{ text: 'Markup', value: 0 },
	{ text: 'Commission', value: 1 },
	{ text: 'Rebate', value: 2 },
	{ text: 'Mkup+Comm', value: 3 }
];

const Booking_Item = {
	units: 1,
	date: [],
	status: Status_Items[0],
	cost: ['0.00'],
	supplier: ['0.00', '0.00'],
	commission: ['0.00',  '0.00'],	
	schedule: ['0.00'],
	net: ['0.00'],
	foc: false,
	mode: Mode_Items[1],
	markup: ['0.00', '0.00'],
	bill: ['0.00'],
	voucher: false,
	nobill: false,
	revenue: ['0.00'],
	deadline: [''],
	margin: ['0.00'],
	is_deleted: false,
	status_id: Planned_Value,
	status_original_id: Planned_Value,
	cost_currency: null,
	schedule_currency: null,
	has_po: false,
	has_cinv: false,
	id: 0,
	index: '0_0',
	is_total: false,
	rev_id: null,
	pos_in_break: '',
	mat_key_identifier: '',
	priority_modifier: '',
	med_ref_id: '',
	booking_day_flags: '',
	booking_start_time: '',
	booking_end_time: '',
	prog_name: '',
	contract_ref: '',
	network_code: '',
	booking_duration: 0
};

const Decimal_Places = 5;
const Link_Icon = '_';
const Left_Header = ['units', 'date', 'status'];

/** Amend Radio Holdings */
const MedRadio = 'MedRadio';
/** Amend media booking */
const MEDED = 'MedEd';
/** Delete media booking */
const MEDDEL = 'MedDel';
/** Manually change the status of a booking */
const MEDSTAT = 'MedStat';
/** Can change status of invoiced media booking */
const MEDINV = 'MedInv';
/* the user will be able to create and amend tasks */
const TR = 'TR';

const Traditional_Booking = 0;
const Radio_Holdings = 1;

export default {
	name: 'MediaPlanBooking',
	props: {
		color: {
			type: String,
			default: '',
		},
		privileges: {
			type: Array,
			default: () => [],
		},
		jobId: {
			type: Number,
			default: 0
		},
		kindParams: {
			type: Object,
			default: null
		},
		mediaId: {
			type: Number,
			default: 0
		},
		supplierId: {
			type: Number,
			default: 0
		},
		bookingEdit: {
			type: Boolean,
			default: true
		}
	},
	data() {
		this.mode_items = Mode_Items;
		this.reversal_value = Reversal_Value;
		this.reversed_value = Reversed_Value;
		this.planned_value = Planned_Value;
		this.left_header = Left_Header;
		this.link_icon = Link_Icon;
		this.task_color = '#81CC00';

		return {
			error_msg: '',
			close_selection: 0,
			loading: false,

			phase_loading: false,
			phase_local: null,
			phase_items: [],

			supplier_loading: false,
			supplier_local: null,
			supplier_items: [],

			kind_loading: false,
			kind_local: null,

			description: '',
			target: '',
			notes: '',
			do_print: true,

			system_client: null,
			system_currency: null,
			cost_currency: null,
			schedule_currency: null,
			
			status: Status_Items,
			status_items: Status_Items,
			mode_items: Mode_Items,

			headers: [
				{
					text: ['Units', ''],
					sortable: false,
					align: 'center',
					value: 'units',
					width: 80
				},
				{
					text: ['Start date - End Date', ''],
					sortable: false,
					align: 'center',
					value: 'date',
					width: 280
				},
				{
					text: ['Status', ''],
					sortable: false,
					divider: true,
					align: 'center',
					value: 'status',
					width: 200
				},
				{
					text: ['Cost Currency', 'Exchange rate'],
					sortable: false,
					align: 'center',
					value: 'cost',
					width: 180
				},
				{
					text: ['Supplier rate ($)', 'Supplier Amount ($)'],
					sortable: false,
					align: 'center',
					value: 'supplier',
					width: 180
				},
				{
					text: ['Commission ($)', 'Commission (%)'],
					sortable: false,
					align: 'center',
					value: 'commission',
					width: 160
				},
				{
					text: ['Schedule Currency', 'Exchange rate'],
					sortable: false,
					align: 'center',
					value: 'schedule',
					width: 180
				},
				{
					text: ['Net ($)', ''],
					sortable: false,
					align: 'center',
					value: 'net',
					width: 180
				},
				{
					text: ['FOC', ''],
					sortable: false,
					align: 'center',
					value: 'foc',
					width: 100
				},
				{
					text: ['Mode', ''],
					sortable: false,
					align: 'center',
					value: 'mode',
					width: 180
				},
				{
					text: ['Mark up / Rebate ($)', 'Mark up / Rebate (%)'],
					sortable: false,
					align: 'center',
					value: 'markup',
					width: 180
				},
				{
					text: ['Bill to client ($)', ''],
					sortable: false,
					align: 'center',
					value: 'bill',
					width: 180
				},
				{
					text: ['Vouchered', ''],
					sortable: false,
					align: 'center',
					value: 'voucher',
					width: 100
				},
				{
					text: ['Do not bill', ''],
					sortable: false,
					align: 'center',
					value: 'nobill',
					width: 100
				},
				{
					text: ['Revenue (%)', ''],
					sortable: false,
					align: 'center',
					value: 'revenue',
					width: 160
				},
				{
					text: ['Material Deadline', ''],
					sortable: false,
					align: 'center',
					value: 'deadline',
					width: 180
				}
			],
			booking_new_item: null,
			booking_list: [],
			booking_list_original: [],

			currency_loading: false,
			currency_items: [],

			cost_rate: {id: 0, rate: '1.0000000'},
			cost_rate_loading: false,
			cost_rate_list: [],

			schedule_rate: {id: 0, rate: '1.0000000'},
			schedule_rate_loading: false,
			schedule_rate_list: [],

			exchange_rate: '0.00',
			system_rate: null,
			markup_perc: 0,
			rebate_perc: 0,

			rate_confirm_visible: false,
			rate_confirm_select: true,
			rate_confirm: { is_cost: true, rate: '0.00' },

			task_visible: false,
			task_amount: 0,
			task_date: [],

			radio_list: [],
			radio_list_original: [],
			radio_table_list: [],

			is_fixed: false,
			offset_top: 0,
			button_height: 0
		}
	},
	components: {
		ProgressLinear,
		DateMulti,
		DatePicker,
		KindTreeSelection,
		Radio,
		MedisPrint,
		Delete,
		RadioTable,
		Calendar,
		NewTask,
		RateConfirmDialog
	},
	async created() {		
		this.booking_new_item = JSON.parse(JSON.stringify(Booking_Item));
		this.booking_new_item['date'] = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];

		await this.getPhaseList();
		await this.getSupplierList();
		await this.getCurrencyList();
		await this.getJobCurrency();
		
		if (this.mediaId !== 0) {
			this.getMediaPlan(this.mediaId);
		}
	},
	mounted() {
		this.$nextTick(() => {
			const el = this.$refs.toolbar;

			this.offset_top = el.offsetTop;
			this.button_height = el.offsetHeight;

			window.addEventListener('scroll', this.handleScroll)
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	computed: {
		isActive() {
			let is_active = false;

			if (this.phase_local && this.supplier_local && this.kind_local && this.description.length !== 0) {
				is_active = true;
			}

			return is_active;
		},
		isSupplierError() {
			let is_supplier_error = false;

			if (!this.supplier_local && (this.kind_local !== null || this.description.length !== 0 || this.target.length !== 0 || this.notes.length !== 0)) {
				is_supplier_error = true;
			}

			return is_supplier_error;
		},
		isKindError() {
			let is_kind_error = false;

			if (!this.kind_local && (this.description.length !== 0 || this.target.length !== 0 || this.notes.length !== 0)) {
				is_kind_error = true;
			}

			return is_kind_error;
		},
		isDescError() {
			let is_desc_error = false;

			if (this.description.length === 0 && (this.target.length !== 0 || this.notes.length !== 0)) {
				is_desc_error = true;
			}

			return is_desc_error;
		},
		isEditableRate() {
			let is_editable = true;

			if (this.booking_list.length !== 0) {
				is_editable = this.booking_list.every(booking => { return booking.status_id === Planned_Value && !booking.rev_id && !booking.has_po});
			}

			return is_editable
		},
		totalValue() {
			const total_value_item = {
				cost: '',
				supplier: '',
				commission: '',	
				schedule: '',
				net: '',
				foc: '',
				mode: '',
				markup: '',
				bill: '',
				voucher: '',
				nobill: '',
				revenue: '',
				deadline: '',
			};

			if (this.booking_list.length !== 0) {
				/** Supplier Amount */
				const supplier_arr = this.booking_list.map(list => { return Number(list.supplier[1]) });
				const supplier_fc_total = supplier_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
				const formatted_supplier_fc = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(supplier_fc_total);
				total_value_item['supplier'] = `${this.cost_currency.code}${Link_Icon}${formatted_supplier_fc}`;

				/** Commission Amount */
				const commission_arr = this.booking_list.map(list => { return Number(list.commission[0]) });
				const commission_fc_total = commission_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
				const formatted_commission_fc = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(commission_fc_total);
				total_value_item['commission'] = `${this.cost_currency.code}${Link_Icon}${formatted_commission_fc}`;

				/** Net -> netamount */
				const net_arr = this.booking_list.map(list => { return Number(list.net[0]) });
				const net_fc_total = net_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
				const formatted_net_fc = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(net_fc_total);
				total_value_item['net'] = `${this.schedule_currency.code}${Link_Icon}${formatted_net_fc}`;


				/** Markup */
				const markup_arr = this.booking_list.map(list => { return Number(list.markup[0]) });
				const markup_fc_total = markup_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
				const formatted_markup_fc = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(markup_fc_total);
				total_value_item['markup'] = `${this.schedule_currency.code}${Link_Icon}${formatted_markup_fc}`;


				/** Bill */
				const bill_arr = this.booking_list.map(list => { return Number(list.bill[0]) });
				const bill_fc_total = bill_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
				const formatted_bill_fc = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(bill_fc_total);
				total_value_item['bill'] = `${this.schedule_currency.code}${Link_Icon}${formatted_bill_fc}`;
			}

			return total_value_item;
		},
		ableEdit() {
			let is_able = true;

			if (this.privileges.length !== 0) {
				if (!this.privileges.includes(MEDED)) {
					is_able = false;
				}
			}

			return is_able;
		},
		ableRadioEdit() {
			let is_able = true;

			if (this.privileges.length !== 0) {
				if (!this.privileges.includes(MedRadio)) {
					is_able = false;
				}
			}

			return is_able;
		},
		ableDelete() {
			let is_able = true;

			if (this.privileges.length !== 0 && this.mediaId !== 0) {
				if (!this.privileges.includes(MEDDEL)) {
					is_able = false;
				}
			}

			return is_able;
		},
		ableStatus() {
			let is_able = true;

			if (this.privileges.length !== 0) {
				if (!this.privileges.includes(MEDSTAT)) {
					is_able = false;
				}
			}

			return is_able;
		},
		ableInv() {
			let is_able = true;

			if (this.privileges.length !== 0) {
				if (!this.privileges.includes(MEDINV)) {
					is_able = false;
				}
			}

			return is_able;
		},
		ableCreateTask() {
			let is_able = true;

			if (this.privileges.length !== 0) {
				if (!this.privileges.includes(TR)) {
					is_able = false;
				}
			}

			return is_able;
		}
	},
	watch: {
		cost_rate: {
			handler: function (newVal, oldVal) {
				if (this.mediaId === 0) {
					if (newVal.id !== oldVal.id || newVal.rate !== oldVal.rate || newVal.currency.id !== oldVal.currency.id) {
						if (this.cost_rate && this.schedule_rate && this.cost_currency && this.schedule_currency) {
							this.onExchangeUpdate();
						}
					}
				}
			},
			deep: true
		},
		schedule_rate: {
			handler: function (newVal, oldVal) {
				if (this.mediaId === 0) {
					if (newVal.id !== oldVal.id || newVal.rate !== oldVal.rate || newVal.currency.id !== oldVal.currency.id) {
						if (this.cost_rate && this.schedule_rate && this.cost_currency && this.schedule_currency) {
							this.onExchangeUpdate();
						}
					}
				}
			},
			deep: true
		},
		exchange_rate() {
			if (this.cost_rate && this.schedule_rate && this.cost_currency && this.schedule_currency) {
				this.onExchangeUpdate();
			}
		}
	},
	methods: {
		handleScroll() {
			this.is_fixed = window.scrollY >= this.offset_top;
		},
		getRowClass(item) {
			const class_text = item.status.value.includes(Reversal_Value) ? 'reversal-row':'';
			return class_text;
		},
		getDateText(date) {
			return `${moment(date[0]).format('DD MMM YYYY')} - ${moment(date[1]).format('DD MMM YYYY')}`;
		},
		filterItem(item_obj) {
			let filter_obj = {};

			const header_value_arr = this.headers.map(header => { return header.value });
			header_value_arr.forEach(header => { 
				filter_obj[`${header}`] = item_obj[`${header}`];
			});

			return filter_obj;
		},
		async getPhaseList() {
			this.phase_loading = true;

			const url = `/api/jobs/${this.jobId}/phases`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.phase_items = data.map((d, index) => { 
							const obj = {
								id: d.id,
								desc: d.display_name,
								order: index
							};

							return obj;
						});

						this.phase_local = this.phase_items[0];
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.phase_loading = false;
				});
		},
		async getSupplierList() {
			this.supplier_loading = true;

			let url = `/api/addressbook/supplier`;

			const params = [];
			params.push("include_media=" + true);
			params.push("include_normal=" + false);
			

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						data.forEach(d => {
							if (d.kind) {
								d.kind['display_name'] = d.kind.name;
							}

							d['desc'] = `${d.code} - ${d.display_name}`
						});
						this.supplier_items = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.supplier_loading = false;
				});
		},
		async getCurrencyList() {
			this.currency_loading = true;

			const url = "/api/expenses/receipts/meta";

			await axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.currency_items = data.currencies;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.currency_loading = false;
				});
		},
		async getJobCurrency() {
			const url = `/api/jobs/${this.jobId}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.system_client = data.client;
						this.system_currency = data.currency;
						this.getExratesForDate(this.system_currency, false, true);

						if (this.mediaId === 0) {
							this.booking_new_item.schedule_currency = data.currency;
							this.schedule_currency = data.currency;
							this.getExratesForDate(this.schedule_currency, false);
							this.getListExrates(this.schedule_currency, false);
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		getListExrates(currency, is_cost) {
			if (is_cost) {
				this.cost_rate_loading = true;
				this.cost_rate_list = [];
			} else {
				this.schedule_rate_loading = true;
				this.schedule_rate_list = [];
			}

			const url = `/api/config/currency/${currency.id}/exchange_rates`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						if (data.length === 0) {
							const today_date = moment().format('YYYY-MM-DD');

							this.getExchangeRates(currency.id, today_date)
								.then(val => {
									const rate_obj = {
										id: val.id,
										date: this.formatDate(val.date),
										is_imported: val.is_imported,
										rate: Number(val.rate).toFixed(Decimal_Places),
										currency: currency
									};

									if (is_cost) {
										this.cost_rate_list.push(rate_obj);
										this.cost_rate = this.cost_rate_list[0];
									} else {
										this.schedule_rate_list.push(rate_obj);
										this.schedule_rate = this.schedule_rate_list[0];
									}
								})
								.catch((reason) => {
									this.error_msg = reason;
								});

						} else {
							const rate_list = [];
							data.forEach(element => {
								const rate_obj = element;
								rate_obj['date'] = this.formatDate(element.date);
								rate_obj['rate'] = Number(element.rate).toFixed(Decimal_Places);
								rate_obj['currency'] = currency;

								rate_list.push(rate_obj);
							});

							if (is_cost) {
								this.cost_rate_list = rate_list;
								this.cost_rate = this.cost_rate_list[0];
							} else {
								this.schedule_rate_list = rate_list;
								this.schedule_rate = this.schedule_rate_list[0];
							}
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.cost_rate_loading = false;
					this.schedule_rate_loading = false;
				})
		},
		getExratesForDate(currency, is_cost=false, is_system=false) {
			const date = moment().format('YYYY-MM-DD');
			let url = `/api/config/currency/${currency.id}/exchange_rates/${date}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						const obj = data;
						obj['rate'] = Number(data.rate).toFixed(Decimal_Places);
						obj['currency'] = currency;

						if (is_system) {
							this.system_rate = obj;
						} else {
							if (is_cost) {
								this.cost_rate = obj;
								this.booking_new_item.cost = [obj.rate];
							} else {
								this.schedule_rate = obj;
								this.booking_new_item.schedule = [obj.rate];
							}
						}
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		getExchangeRates(currency_id, date) {
			const url = `/api/config/currency/${currency_id}/exchange_rates/${date}`;

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});		
		},
		async getMarkup(job_id, supplier_id, kind_id) {
			let url = `/api/config/rates/markup`;

			const params = [];
			params.push("job_id=" + job_id);
			params.push("supplier_id=" + supplier_id);
			if (kind_id) {
				params.push("kind_id=" + kind_id);
			}

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.markup_perc = new Decimal(data * 100).toDecimalPlaces(Decimal_Places).toNumber();
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		async getRebatePercentage(job_id, client_id, kind_id) {
			let url = `/api/config/rates/rebate_percentage`;

			const params = [];
			params.push("job_id=" + job_id);
			params.push("client_id=" + client_id);
			
			if (kind_id) {
				params.push("kind_id=" + kind_id);
			}

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.rebate_perc = new Decimal(data).toDecimalPlaces(Decimal_Places).toNumber();
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		getMediaPlan(media_id) {
			const url = `/api/media/media_planning/${media_id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const phase_obj = data.phase;
						phase_obj['desc'] = phase_obj.display_name;
						this.phase_local = phase_obj;

						const supplier_id = this.supplierId !== 0 ? this.supplierId : data.supplier.id;
						const supplier_obj = (this.supplier_items.filter(s => { return s.id === supplier_id }))[0];
						supplier_obj['kind'] = data.kind
						this.supplier_local = supplier_obj;

						this.kind_local = data.kind;
						this.description = data.desc;
						this.target = data.target;
						this.notes = data.notes;
						this.do_print = data.print;

						this.getMarkup(this.jobId, this.supplier_local.id, this.kind_local ? this.kind_local.id : null);
						this.getRebatePercentage(this.jobId, this.system_client.id, this.kind_local ? this.kind_local.id : null);

						this.booking_new_item.cost_currency = this.supplier_local.currency;
						this.booking_new_item.commission[1] = Number(this.supplier_local.commission_perc).toFixed(2);
						
						if (this.rebate_perc !== 0) {
							this.booking_new_item.mode = Mode_Items[2];
							this.booking_new_item.markup[1] = Number(this.rebate_perc).toFixed(2);
						} else {
							/** if commission_perc = 0, mode => markup */
							if (Number(this.supplier_local.commission_perc) === 0) {
								this.booking_new_item.mode = Mode_Items[0];
								this.booking_new_item.markup[1] = Number(this.markup_perc).toFixed(2);
							} else {
								this.booking_new_item.mode = Mode_Items[1];
								this.booking_new_item.markup[1] = '0.00';
							}
						}

						this.cost_currency = data.cost_currency;
						this.schedule_currency = data.value_currency;
						this.exchange_rate = Number(data.exrate_margin_perc).toFixed(2);
						
						this.getListExrates(this.cost_currency, true);
						this.getListExrates(this.schedule_currency, false);

						this.getBookings(this.jobId, this.phase_local.id, this.mediaId);

					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => { 
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		getBookings(job_id, phase_id, plan_id) {
			this.loading = true;
			this.booking_list = [];
			this.booking_list_original = [];
			this.radio_list = [];
			this.radio_list_original = [];

			const params = [];
			params.push("job_id=" + job_id);
			params.push("phase_id=" + phase_id);
			params.push('plan_id=' + plan_id);

			let url = "/api/media/media_planning/booking";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;
					if (status === 'OK') {
						const data_radio = data.filter(d => { return d.booking_type === Radio_Holdings });
						this.radio_list = data_radio;
						this.radio_list_original = JSON.parse(JSON.stringify(data_radio));

						const data_booking = data.filter(d => { return d.booking_type === Traditional_Booking });
						const reversal_filter = data_booking.filter(d => { return d.rev_id !== null && d.rev_id > 1 });
						const normal_filter = data_booking.filter(d => { return d.rev_id === null || d.rev_id === 1 });

						normal_filter.sort((a,b) => { 
							if (a.booking_start !== b.booking_start) {
								return a.booking_start - b.booking_start;
							} else {
								const a_rev_id = a.rev_id === null ? 0 : a.rev_id;
								const b_rev_id = b.rev_id === null ? 0 : b.rev_id;
								if (a_rev_id !== b_rev_id) {
									return b_rev_id - a_rev_id;
								} else {
									return a.id - b.id;
								}
							}
						});

						const reversed_filter = normal_filter.filter(normal => { return normal.rev_id !== null && normal.rev_id === 1 });
						for (let index = 0; index < reversed_filter.length; index++) {
							const reversed = reversed_filter[index];
							const reversed_index = normal_filter.findIndex(normal => normal.id === reversed.id );
							const insert_element = reversal_filter.filter(reversal => { return reversal.rev_id === reversed.id } );
							normal_filter.splice(reversed_index + 1, 0 , insert_element[0])
						}

						normal_filter.forEach(b => {
							let status_filter_arr = [];
							if (b.rev_id && b.rev_id === 1) {
								status_filter_arr = Status_Items.filter(s => { return s.value.includes(Reversed_Value) });
							} else if (b.rev_id && b.rev_id > 1) {
								status_filter_arr = Status_Items.filter(s => { return s.value.includes(Reversal_Value) });
							} else {
								if (b.status === Planned_Value && b.has_po === true) {
									status_filter_arr = Status_Items.filter(s => { return s.value.includes(Unapproved_Value) });
								} else {
									status_filter_arr = Status_Items.filter(s => { return s.value.includes(b.status) });
								}
							}				
				
							const booking_item = {
								units: b.units,
								date: [moment(b.booking_start, 'YYYYMMDD').format('YYYY-MM-DD'), moment(b.booking_end, 'YYYYMMDD').format('YYYY-MM-DD')],
								status: status_filter_arr[0],
								cost: [Number(b.exrate_cost).toFixed(Decimal_Places)],
								supplier: [Number(b.rate_fc).toFixed(2), Number(b.amount_fc).toFixed(2)],
								commission: [Number(b.commamount_fc).toFixed(2),  Number(b.comm_perc).toFixed(2)],
								schedule: [Number(b.exrate_value).toFixed(Decimal_Places)],
								net: [Number(b.net_fc).toFixed(2)],
								foc: b.is_foc,
								mode: (Mode_Items.filter(mode => { return mode.value === b.booking_mode }))[0],
								markup: [Number(b.markupamount_fc).toFixed(2) , Number(b.markup_perc).toFixed(2)],
								bill: [Number(b.value_fc).toFixed(2)],
								voucher: b.is_vouchered,
								nobill: b.donotbill,
								revenue: [Number(b.revenue_perc).toFixed(2)],
								deadline: b.material_deadline && b.material_deadline.length !== 0 ? [moment(b.material_deadline, 'YYYYMMDD').format('YYYY-MM-DD')] : [''],
								margin: [this.exchange_rate],
								is_deleted: b.is_deleted,
								status_id: b.status,
								status_original_id: b.status,
								cost_currency: this.cost_currency,
								schedule_currency: this.schedule_currency,
								has_po: b.has_po,
								has_cinv: b.has_cinv,
								id: b.id,
								index: `0_${b.id}`,
								is_total: false,
								rev_id: b.rev_id,
								pos_in_break: b.pos_in_break,
								mat_key_identifier: b.material_key_identifier,
								priority_modifier: b.priority_modifier,
								med_ref_id: b.media_reference_id,
								booking_day_flags: b.booking_day_flags,
								booking_start_time: b.booking_start_time,
								booking_end_time: b.booking_end_time,
								prog_name: b.program_name,
								contract_ref: b.contract_ref,
								network_code: b.network_code,
								booking_duration: b.booking_duration
							};

							this.booking_list.push(booking_item);
							this.booking_list_original.push(booking_item);
						});
					} else {
						this.$emit('error', reason)
					}
				})
				.catch((e) => {
					this.$emit('error', e.message);
				})
				.finally(() => {
					this.loading = false;
				});

		},
		numberFormat(num_str) {
			let number_format = '';

			if (typeof(num_str) === 'string' && num_str.length !== 0) {
				number_format = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(num_str);
			}
			return number_format;
		},
		formatDate(date) {
			let date_tmp = '';

			if (typeof(date) === 'string' && date.length !== 0) {
				date_tmp = moment(date).format('DD MMM YYYY')
			}

			return date_tmp;
		},
		filterStatus(status_id) {
			let status_list = [];

			const status_items_copy = JSON.parse(JSON.stringify(Status_Items));

			if (status_id !== 0) {
				/** planned */
				if (status_id === 1) {
					status_list = status_items_copy.filter(item => { return item.key === 'booked' || item.key === 'planned'});
				}
				/** booked */
				if (status_id === 2) {
					status_list = status_items_copy.filter(item => { return item.key === 'planned' || item.key === 'invoiced' || item.key === 'booked'});
				}
				/** test_invoice */
				if (status_id === 3) {
					status_list = status_items_copy.filter(item => { return item.key === 'planned' || item.key === 'invoiced' || item.key === 'booked' || item.key === 'test_invoice'});
				}
				/** invoiced */
				if (status_id === 4) {
					status_list = status_items_copy.filter(item => { return item.key === 'planned' || item.key === 'invoiced' || item.key === 'booked' });
				}
				/** note */
				if (status_id === 5) {
					status_list = status_items_copy.filter(item => { return item.key === 'planned' || item.key === 'invoiced' || item.key === 'booked' || item.key === 'note' });
				}

				status_list[status_list.length - 1].last = true;
			}

			return status_list;
		},
		tickableVouch(booking) {
			let is_able = true;

			if (booking.rev_id && booking.rev_id === Planned_Value) {
				/** Reversed */
				is_able = false;
			}

			if (booking.rev_id && booking.rev_id > Planned_Value) {
				/** Reversal */
				is_able = false;
			}
			
			return is_able
		},
		tickableFOC(booking) {
			let is_able = true;

			if (booking.status_id === Planned_Value && !booking.rev_id) {
				/** Planned */
				if (booking.has_po) {
					is_able = false;
				} else {
					is_able = true;
				}
			}

			const booked_filter = Status_Items.filter(s => { return s.key === 'booked'});
			if (booked_filter[0].value.includes(booking.status_id)) {
				/** Booked */
				is_able = false;
			}

			const test_invoice_filter = Status_Items.filter(s => { return s.key === 'test_invoice'});
			if (test_invoice_filter[0].value.includes(booking.status_id)) {
				/** Test Invoice */
				is_able = false;
			}

			const invoiced_filter = Status_Items.filter(s => { return s.key === 'invoiced'});
			if (invoiced_filter[0].value.includes(booking.status_id)) {
				/** Invoiced */
				is_able = false;
			}

			const note_filter = Status_Items.filter(s => { return s.key === 'note'});
			if (note_filter[0].value.includes(booking.status_id)) {
				/** Test Credit Note */
				is_able = false;
			}

			if (booking.rev_id && booking.rev_id === Planned_Value) {
				/** Reversed */
				is_able = false;
			}

			if (booking.rev_id && booking.rev_id > Planned_Value) {
				/** Reversal */
				is_able = false;
			}

			return is_able;
		},
		tickableDoNoBill(booking) {
			let is_able = true;

			if (booking.status_id === Planned_Value && !booking.rev_id) {
				/** Planned */
				if (booking.has_po) {
					is_able = false;
				} else {
					is_able = true;
				}
			}

			const booked_filter = Status_Items.filter(s => { return s.key === 'booked'});
			if (booked_filter[0].value.includes(booking.status_id)) {
				/** Booked */
				if (booking.has_cinv) {
					is_able = false;
				} else {
					is_able = true;
				}
			}

			const test_invoice_filter = Status_Items.filter(s => { return s.key === 'test_invoice'});
			if (test_invoice_filter[0].value.includes(booking.status_id)) {
				/** Test Invoice */
				if (booking.has_cinv) {
					is_able = false;
				} else {
					is_able = true;
				}
			}

			const invoiced_filter = Status_Items.filter(s => { return s.key === 'invoiced'});
			if (invoiced_filter[0].value.includes(booking.status_id)) {
				/** Invoiced */
				is_able = false;
			}

			const note_filter = Status_Items.filter(s => { return s.key === 'note'});
			if (note_filter[0].value.includes(booking.status_id)) {
				/** Test Credit Note */
				is_able = false;
			}

			if (booking.rev_id && booking.rev_id === Planned_Value) {
				/** Reversed */
				is_able = false;
			}

			if (booking.rev_id && booking.rev_id > Planned_Value) {
				/** Reversal */
				is_able = false;
			}

			return is_able;
		},
		onRefresh() {
			this.getBookings(this.jobId, this.phase_local.id, this.mediaId);
		},
		onSupplierChange() {
			if (this.supplier_local) {
				if (this.supplier_local.kind) {
					this.kind_local = this.supplier_local.kind;
				} else {
					this.kind_local = null;
				}
				
				this.cost_currency = this.supplier_local.currency;
				this.getExratesForDate(this.cost_currency, true);
				this.getListExrates(this.cost_currency, true);

				this.getMarkup(this.jobId, this.supplier_local.id, this.kind_local ? this.kind_local.id : null);
				this.getRebatePercentage(this.jobId, this.system_client.id, this.kind_local ? this.kind_local.id : null);

				this.booking_new_item.cost_currency = this.supplier_local.currency;
				this.booking_new_item.commission[1] = Number(this.supplier_local.commission_perc).toFixed(2);

				if (this.rebate_perc !== 0) {
					this.booking_new_item.mode = Mode_Items[2];
					this.booking_new_item.markup[1] = Number(this.rebate_perc).toFixed(2);
				} else {
					/** if commission_perc = 0, mode => markup */
					if (Number(this.supplier_local.commission_perc) === 0) {
						this.booking_new_item.mode = Mode_Items[0];
						this.booking_new_item.markup[1] = Number(this.markup_perc).toFixed(2);
					} else {
						this.booking_new_item.mode = Mode_Items[1];
						this.booking_new_item.markup[1] = '0.00';
					}
				}
				
			}
		},
		onKindChange(event) {
			this.kind_local = event;

			if (this.supplier_local) {
				this.getMarkup(this.jobId, this.supplier_local.id, this.kind_local ? this.kind_local.id : null)
			}

			this.getRebatePercentage(this.jobId, this.system_client.id, this.kind_local ? this.kind_local.id : null);

			if (this.rebate_perc !== 0) {
				this.booking_new_item.mode = Mode_Items[2];
				this.booking_new_item.markup[1] = Number(this.rebate_perc).toFixed(2);
			} else {
				if (Number(this.supplier_local.commission_perc) === 0) {
					this.booking_new_item.mode = Mode_Items[0];
					this.booking_new_item.markup[1] = Number(this.markup_perc).toFixed(2);
				} else {
					this.booking_new_item.mode = Mode_Items[1];
					this.booking_new_item.markup[1] = '0.00';
				}
			}
		},
		onStatusFilte(status) {
			let status_value_arr = [];
			status.forEach(s => { status_value_arr = [...status_value_arr, ...s.value] });

			this.booking_list = this.booking_list_original.filter(b => { return status_value_arr.includes(b.status.value[0]) });
			this.radio_list = this.radio_list_original.filter(b => { return status_value_arr.includes(b.status) });
		},
		onStatusChange(status, booking) {
			this.booking_list.forEach(b => {
				if (b.id === booking.id) {
					b['status_id'] = status.value[0];
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.id === booking.id) {
					b['status_id'] = status.value[0];
				}
			});
		},
		onChangeUnit(unit, item_index) {
			const booking_item = this.booking_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.units = Number(unit);
			const booking_new = this._calculateBookingAmount(new_booking_item, false);

			this.booking_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`];
					}
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`];
					}
				}
			});
		},
		onChangeDate(date_arr, item_index) {
			this.error_msg = '';

			if (date_arr.length === 2) {
				this.booking_list.forEach(b => {
					if (b.index === item_index) {
						b.date = date_arr;
					}
				});

				this.booking_list_original.forEach(b => {
					if (b.index === item_index) {
						b.date = date_arr;
					}
				});
			}
		},
		onChangeSupplier(supplier, item_index) {
			let number_parse = '';
			if (supplier.includes(',')) {
				const numberString = supplier.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(supplier).toFixed(2);
			}

			const booking_item = this.booking_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.supplier[0] = number_parse;
			const booking_new = this._calculateBookingAmount(new_booking_item, false);

			this.booking_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeCommission(commission, item_index, index) {
			let number_parse = '';
			if (commission.includes(',')) {
				const numberString = commission.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(commission).toFixed(2);
			}

			const booking_item = this.booking_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.commission[`${index}`] = number_parse;

			const is_commission_amount = index === 0 ? true : false;
			const booking_new = this._calculateBookingAmount(new_booking_item, is_commission_amount);

			this.booking_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeRate(rate) {
			let number_parse = '';
			if (rate.includes(',')) {
				const numberString = rate.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(rate).toFixed(2);
			}

			this.exchange_rate = number_parse;

			const booking_item = this.booking_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item['margin'] = [this.exchange_rate];

			const booking_new = this._calculateBookingAmount(new_booking_item, false);


			this.booking_list.forEach(b => {
				if (b.status_id === Planned_Value && !b.rev_id) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`];
					}
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.status_id === Planned_Value && !b.rev_id) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`];
					}
				}
			});
		},
		onChangeNet(net, item_index) {
			let number_parse = '';
			if (net.includes(',')) {
				const numberString = net.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(net).toFixed(2);
			}

			const booking_item = this.booking_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.net = [number_parse];
			const booking_new = this._calculateBookingNet(new_booking_item);

			this.booking_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeFOC(foc, item_index) {
			const booking_item = this.booking_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.foc = foc;
			const booking_new = this._calculateBookingFOC(new_booking_item);

			this.booking_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeMode(mode, item_index) {
			const booking_item = this.booking_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.mode = mode;
			const booking_new = this._calculateBookingMode(new_booking_item, false);

			this.booking_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeMarkup(markup, item_index, index) {
			let number_parse = '';
			if (markup.includes(',')) {
				const numberString = markup.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(markup).toFixed(2);
			}

			const booking_item = this.booking_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.markup[`${index}`] = number_parse;
			const booking_new = this._calculateBaseMode(new_booking_item, index === 0 ? true : false, index === 1 ? true : false, false);

			this.booking_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeBill(bill, item_index) {
			let number_parse = '';
			if (bill.includes(',')) {
				const numberString = bill.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(bill).toFixed(2);
			}

			const booking_item = this.booking_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.bill = [number_parse];
			const booking_new = this._calculateBaseMode(new_booking_item, false, false, true);

			this.booking_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeDeadLineDate(date, item_index) {
			this.error_msg = '';

			if (date && date.length !== 0) {
				this.booking_list.forEach(b => {
					if (b.index === item_index) {
						b.deadline = [date];
					}
				});

				this.booking_list_original.forEach(b => {
					if (b.index === item_index) {
						b.deadline = [date];
					}
				});
			} else {
				this.booking_list.forEach(b => {
					if (b.index === item_index) {
						b.deadline = [''];
					}
				});

				this.booking_list_original.forEach(b => {
					if (b.index === item_index) {
						b.deadline = [''];
					}
				});
			}
		},
		onRateChange(event, is_cost) {
			let rate_obj_copy = is_cost ? JSON.parse(JSON.stringify(this.cost_rate)) : JSON.parse(JSON.stringify(this.schedule_rate));
			
			if (typeof(event) === 'string') {
				rate_obj_copy['rate'] = Number(event).toFixed(5);
			} else {
				rate_obj_copy = event;
			}
			rate_obj_copy['is_cost'] = is_cost;
			
			
			this.rate_confirm = rate_obj_copy;

			if (this.mediaId === 0) {
				if (this.rate_confirm.is_cost) {
					this.cost_rate = this.rate_confirm;
				} else {
					this.schedule_rate = this.rate_confirm;
				}
			} else {
				this.rate_confirm_visible = true;
			}
		},
		onConfirmRate(is_ok) {
			if (this.rate_confirm.is_cost) {
				this.cost_rate = this.rate_confirm;
			} else {
				this.schedule_rate = this.rate_confirm;
			}
				
			if (is_ok) {
				this.onExchangeUpdate(this.rate_confirm.is_cost ? 'cost':'schedule');
			}

			this.rate_confirm_visible = false;
		},
		onExchangeUpdate(update_key='') {
			this.booking_list.forEach(b => {
				if (b.status_id === Planned_Value && !b.rev_id && !b.has_po) {
					const booking_new = JSON.parse(JSON.stringify(b));
					if (update_key.length === 0) {
						booking_new['cost'] = [this.cost_rate.rate];
						booking_new['schedule'] = [this.schedule_rate.rate];
					} else {
						if (update_key === 'cost') {
							booking_new['cost'] = [this.cost_rate.rate];
						}
						if (update_key === 'schedule') {
							booking_new['schedule'] = [this.schedule_rate.rate];
						}
					}
					booking_new['cost_currency'] = this.cost_currency;
					booking_new['schedule_currency'] = this.schedule_currency;
					booking_new['margin'] = [this.exchange_rate];

					const booking_new_cal = this._calculateBookingAmount(booking_new, false);

					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new_cal[`${key}`];
					}
				}
			});

			this.booking_list_original.forEach(b => {
				if (b.status_id === Planned_Value && !b.rev_id && !b.has_po) {
					const booking_new = JSON.parse(JSON.stringify(b));
					if (update_key.length === 0) {
						booking_new['cost'] = [this.cost_rate.rate];
						booking_new['schedule'] = [this.schedule_rate.rate];
					} else {
						if (update_key === 'cost') {
							booking_new['cost'] = [this.cost_rate.rate];
						}
						if (update_key === 'schedule') {
							booking_new['schedule'] = [this.schedule_rate.rate];
						}
					}
					
					booking_new['cost_currency'] = this.cost_currency;
					booking_new['schedule_currency'] = this.schedule_currency;
					booking_new['margin'] = [this.exchange_rate];

					const booking_new_cal = this._calculateBookingAmount(booking_new, false, false);

					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new_cal[`${key}`];
					}
				}
			});
		},
		onDeleteBooking(item) {
			this.booking_list = this.booking_list.filter(b => { return b.index !== item.index });
			this.booking_list_original = this.booking_list_original.filter(b => { return b.index !== item.index });
		},
		onReverseBooking(item) {
			const status_reversed_arr = Status_Items.filter(s => { return s.value.includes(Reversed_Value) });
			item['status'] = status_reversed_arr[0];
			item['rev_id'] = 1;
			if (!item.has_cinv) {
				item['nobill'] = true;
			}

			/** create a reversal booking line automatically */
			const reversal_item = JSON.parse(JSON.stringify(item));
			reversal_item['id'] = 0;
			reversal_item['index'] = this._getNewIndex();
			reversal_item['rev_id'] = item.id;
			if (!reversal_item.has_cinv) {
				reversal_item['nobill'] = true;
			}

			const status_reversal_arr = Status_Items.filter(s => { return s.value.includes(Reversal_Value) });
			reversal_item['status'] = status_reversal_arr[0];

			const supplier_rate = Number(reversal_item.supplier[0]) === 0 ? Number(reversal_item.supplier[0]) : -Number(reversal_item.supplier[0]);
			const supp_amount = Number(reversal_item.supplier[1]) === 0 ? Number(reversal_item.supplier[1]) : -Number(reversal_item.supplier[1]);
			reversal_item['supplier'] = [Number(supplier_rate).toFixed(2), Number(supp_amount).toFixed(2)];
			
			const commission_amount = Number(reversal_item.commission[0]) === 0 ? Number(reversal_item.commission[0]) : -Number(reversal_item.commission[0]);
			reversal_item['commission'] = [Number(commission_amount).toFixed(2), reversal_item.commission[1]];
			
			const net = Number(reversal_item.net[0]) === 0 ? Number(reversal_item.net[0]) : -Number(reversal_item.net[0]);
			reversal_item['net'] = [Number(net).toFixed(2)];

			const markup = Number(reversal_item.markup[0]) === 0 ? Number(reversal_item.markup[0]) : -Number(reversal_item.markup[0]);
			reversal_item['markup'] = [Number(markup).toFixed(2), reversal_item.markup[1]];

			const bill = Number(reversal_item.bill[0]) === 0 ? Number(reversal_item.bill[0]) : -Number(reversal_item.bill[0]);
			reversal_item['bill'] = [Number(bill).toFixed(2)];

			/** create a new booking line automatically */
			const reversal_item_plan = JSON.parse(JSON.stringify(item));
			reversal_item_plan['id'] = 0;
			reversal_item_plan['index'] = this._getNewIndex() + 1;
			reversal_item_plan['rev_id'] = null;
			reversal_item_plan['status_id'] = Planned_Value;
			reversal_item_plan['status_original_id'] = Planned_Value;
			reversal_item_plan['nobill'] = false;
			reversal_item_plan['has_po'] = false;
			reversal_item_plan['has_cinv'] = false;

			const status_plan_arr = Status_Items.filter(s => { return s.value.includes(Planned_Value) });
			reversal_item_plan['status'] = status_plan_arr[0];

			const insert_index = this.booking_list.findIndex(booking => { return booking.id === item.id });
			this.booking_list.splice(insert_index + 1, 0, reversal_item, reversal_item_plan);
			this.booking_list_original.splice(insert_index + 1, 0, reversal_item, reversal_item_plan);
		},
		onCreateTask(item) {
			let bill = 0;
			
			if (this.schedule_currency.id === this.system_currency.id) {
				bill = Number(item.bill[0]);
			} else {
				const ex_rate_system = new Decimal(this.system_rate.rate).toDecimalPlaces(Decimal_Places);
				const ex_rate_schedule = new Decimal(this.schedule_rate.rate).toDecimalPlaces(Decimal_Places);
				const bill_convert = new Decimal(item.bill[0]).div(ex_rate_schedule).times(ex_rate_system).toDecimalPlaces(Decimal_Places);

				bill = Number(bill_convert.toFixed(2));
			}

			this.task_amount = bill;
			this.task_date = [item.date[0], item.date[1]];
			this.task_visible = true;
		},
		onAddBooking() {
			const booking_copy = this.booking_list.length === 0 ? this.booking_new_item : this.booking_list[this.booking_list.length - 1];
			const new_booking = JSON.parse(JSON.stringify(booking_copy));

			new_booking['id'] = 0;
			new_booking['index'] = this._getNewIndex();
			new_booking['status'] = Status_Items[0];
			new_booking['has_po'] = false;
			new_booking['has_cinv'] = false;
			new_booking['is_deleted'] = false;
			new_booking['rev_id'] = null;
 
			if (this.booking_list.length !== 0) {
				const last_date = this.booking_list[this.booking_list.length - 1].date;
				new_booking['date'] = [moment(last_date[1]).add(1, 'day').format('YYYY-MM-DD'), moment(last_date[1]).add(1, 'day').format('YYYY-MM-DD')];
			} else {
				new_booking['date'] = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
			}

			if (this.rebate_perc !== 0) {
				new_booking['mode'] = Mode_Items[2];
				new_booking.markup[1] = Number(this.rebate_perc).toFixed(2);
			} else {
				if (Number(this.supplier_local.commission_perc) === 0) {
					new_booking['mode'] = Mode_Items[0];
					new_booking.markup[1] = Number(this.markup_perc).toFixed(2);
				} else {
					new_booking['mode'] = Mode_Items[1];
					new_booking['markup'] = ['0.00', '0.00'];
				}
			}

			new_booking['commission'] = [new_booking.commission[0], new_booking.commission[1]];
			new_booking['cost'] = [this.cost_rate.rate];
			new_booking['schedule'] = [this.schedule_rate.rate];
			new_booking['cost_currency'] = this.cost_currency;
			new_booking['schedule_currency'] = this.schedule_currency;
			new_booking['margin'] = [this.exchange_rate];

			
			this.booking_list.push(new_booking);
			this.booking_list_original.push(new_booking);
		},
		onCreateMedia() {
			const url = '/api/media/media_planning';
			const params_obj = this._getParams();

			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.$emit('close', true)
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onSaveMedia() {
			const url = `/api/media/media_planning/${this.mediaId}`;
			const params_obj = this._getParams();

			axios
				.put(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.$emit('close', true)
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		_getParams() {
			const params = {};

			params['id'] = this.mediaId;
			params['phase_id'] = this.phase_local.id;
			params['supplier_id'] = this.supplier_local.id;
			params['kind_id'] = this.kind_local.id;
			params['cost_curr_id'] = this.cost_currency.id;
			params['value_curr_id'] = this.schedule_currency.id;
			params['description'] = this.description;
			params['target'] = this.target;
			params['notes'] = this.notes;
			params['do_print'] = this.do_print;
			params['exrate_margin_perc'] = Number(this.exchange_rate) === 0 ? 0 : Number(this.exchange_rate);

			let total_bookings = [];
			this.booking_list.forEach(b => { b['is_radio'] = false });
			total_bookings = [...this.booking_list];

			if (this.radio_list.length !== 0 && this.radio_table_list.length !== 0) {
				this.radio_table_list.forEach(b => { b['is_radio'] = true });
				total_bookings = [...total_bookings, ...this.radio_table_list];
			}

			
			const bookings = [];
			total_bookings.forEach(b => {
				const booking_obj = {};

				booking_obj['id'] = b.id;
				booking_obj['booking_type'] = b.is_radio === true ? 1 : 0; // 0-traditional booking, 1- radio holdings
				booking_obj['plan_id'] = this.mediaId !== 0 ? this.mediaId : 0;

				/** Reversed, rev_id=1;  Reversal, rev_id=reversed booking id */
				if (b.status.value.includes(Reversed_Value)) {
					booking_obj['rev_id'] = 1;
				}
				if (b.status.value.includes(Reversal_Value)) {
					booking_obj['rev_id'] = b.rev_id;
				}
				
				booking_obj['units'] = b.units;
				booking_obj['booking_start'] = b.date[0];
				booking_obj['booking_end'] = b.is_radio === true ? moment(b.booking_end, 'YYYYMMDD').format('YYYY-MM-DD') : b.date[1];
				if (b.is_radio) {
					const booked_date = moment.parseZone(b.booked_date).utc();
					booking_obj['booked_date'] = booked_date.isValid() ? booked_date.format('YYYY-MM-DD HH:mm:ss') : null;
				}
				
				if (b.status.value.includes(Reversal_Value)) {
					booking_obj['status'] = Status_Items[0].value[0];
				} else {
					booking_obj['status'] = b.status_id;
				}
				
				booking_obj['is_foc'] = b.foc;
				booking_obj['comm_perc'] = Number(b.commission[1]) === 0 ? 0 : Number(b.commission[1]);
				booking_obj['booking_mode'] = b.mode.value;
				booking_obj['markup_perc'] = Number(b.markup[1]) === 0 ? 0 : Number(b.markup[1]);
				booking_obj['donotbill'] = b.nobill;
				booking_obj['exrate_div'] = Number(this.system_rate.rate) === 0 ? 0 : Number(this.system_rate.rate);
				booking_obj['exrate_cost'] = Number(b.cost[0]) === 0 ? 0 : Number(b.cost[0]);
				booking_obj['exrate_value'] = Number(b.schedule[0]) === 0 ? 0 : Number(b.schedule[0]);
				booking_obj['is_deleted'] = b.is_deleted;
				booking_obj['is_vouchered'] = b.voucher;

				/** fc -> user typing,  div -> exchange with division rate(from job) */
				booking_obj['rate_fc'] = Number(b.supplier[0]) === 0 ? 0 : Number(b.supplier[0]);
				booking_obj['amount_fc'] = Number(b.supplier[1]) === 0 ? 0 : Number(b.supplier[1]);
				booking_obj['commamount_fc'] = Number(b.commission[0]) === 0 ? 0 : Number(b.commission[0]);
				booking_obj['net_fc'] = Number(b.net[0]) === 0 ? 0 : Number(b.net[0]);
				booking_obj['markupamount_fc'] = Number(b.markup[0]) === 0 ? 0 : Number(b.markup[0]);
				booking_obj['value_fc'] =  Number(b.bill[0]) === 0 ? 0 : Number(b.bill[0]);

				let margin_fc = 0;
				if (this.cost_currency.id === this.schedule_currency.id) {
					const supplier_amount = new Decimal(b.supplier[1]).toDecimalPlaces(Decimal_Places);
					const commission_amount = new Decimal(b.commission[0]).toDecimalPlaces(Decimal_Places);
					const net = supplier_amount.minus(commission_amount).toDecimalPlaces(Decimal_Places);
					margin_fc = net.times(this.exchange_rate).div(100).toDecimalPlaces(Decimal_Places);
				} else {
					const supplier_amount_sys = new Decimal(b.supplier[1]).div(this.cost_rate.rate).toDecimalPlaces(Decimal_Places);
					const commission_amount_sys = new Decimal(b.commission[0]).div(this.cost_rate.rate).toDecimalPlaces(Decimal_Places);
					const net_sys = supplier_amount_sys.minus(commission_amount_sys).toDecimalPlaces(Decimal_Places);
					const net_schedule = net_sys.times(this.schedule_rate.rate).toDecimalPlaces(Decimal_Places);
					margin_fc = net_schedule.times(this.exchange_rate).div(100).toDecimalPlaces(Decimal_Places);
				}
				booking_obj['margin_fc'] = Number(margin_fc) === 0 ? 0 : Number(margin_fc);

				if (this.cost_currency.id === this.system_currency.id) {
					booking_obj['rate_div'] = Number(b.supplier[0]) === 0 ? 0 : Number(b.supplier[0]);
					booking_obj['amount_div'] = Number(b.supplier[1]) === 0 ? 0 : Number(b.supplier[1]);
					booking_obj['commamount_div'] = Number(b.commission[0]) === 0 ? 0 : Number(b.commission[0]);
				} else {
					const ex_rate_system = new Decimal(this.system_rate.rate).toDecimalPlaces(Decimal_Places);
					const ex_rate_cost = new Decimal(this.cost_rate.rate).toDecimalPlaces(Decimal_Places);
	
					const rate = new Decimal(b.supplier[0]).div(ex_rate_cost).times(ex_rate_system).toDecimalPlaces(Decimal_Places);
					booking_obj['rate_div'] = Number(rate) === 0 ? 0 : Number(rate)

					const amount = new Decimal(b.supplier[1]).div(ex_rate_cost).times(ex_rate_system).toDecimalPlaces(Decimal_Places);
					booking_obj['amount_div'] = Number(amount) === 0 ? 0 : Number(amount);

					const commamount = new Decimal(b.commission[0]).div(ex_rate_cost).times(ex_rate_system).toDecimalPlaces(Decimal_Places);
					booking_obj['commamount_div'] = Number(commamount) === 0 ? 0 : Number(commamount);
				}

				if (this.schedule_currency.id === this.system_currency.id) {
					booking_obj['margin_div'] = Number(margin_fc) === 0 ? 0 : Number(margin_fc);
					booking_obj['net_div'] = Number(b.net[0]) === 0 ? 0 : Number(b.net[0]);
					booking_obj['markupamount_div'] = Number(b.markup[0]) === 0 ? 0 : Number(b.markup[0]);
					booking_obj['value_div'] = Number(b.bill[0]) === 0 ? 0 : Number(b.bill[0]);
				} else {
					const ex_rate_system = new Decimal(this.system_rate.rate).toDecimalPlaces(Decimal_Places);
					const ex_rate_schedule = new Decimal(this.schedule_rate.rate).toDecimalPlaces(Decimal_Places);
					
					const margin = new Decimal(margin_fc).div(ex_rate_schedule).times(ex_rate_system).toDecimalPlaces(Decimal_Places);
					booking_obj['margin_div'] = Number(margin) === 0 ? 0 : Number(margin);

					const net = new Decimal(b.net[0]).div(ex_rate_schedule).times(ex_rate_system).toDecimalPlaces(Decimal_Places);
					booking_obj['net_div'] = Number(net) === 0 ? 0 : Number(net);

					const markup = new Decimal(b.markup[0]).div(ex_rate_schedule).times(ex_rate_system).toDecimalPlaces(Decimal_Places);
					booking_obj['markupamount_div'] = Number(markup) === 0 ? 0 : Number(markup);

					const bill = new Decimal(b.bill[0]).div(ex_rate_schedule).times(ex_rate_system).toDecimalPlaces(Decimal_Places);
					booking_obj['value_div'] = Number(bill) === 0 ? 0 : Number(bill);
				}

				/** radio holidings */
				booking_obj['pos_in_break'] = this.mediaId === 0 ? '': (b.is_radio === true ? b.pos_in_break[0] : b.pos_in_break);
				booking_obj['mat_key_identifier'] = this.mediaId === 0 ? '' : (b.is_radio === true ? b.material_key[0] : b.mat_key_identifier);
				booking_obj['priority_modifier'] = this.mediaId === 0 ? '' : (b.is_radio === true ? b.priority[0] : b.priority_modifier);
				booking_obj['med_ref_id'] = this.mediaId === 0 ? '' : b.med_ref_id;
				booking_obj['booking_day_flags'] = this.mediaId === 0 ? '' : b.booking_day_flags;
				booking_obj['booking_start_time'] = this.mediaId === 0 ? '' : b.booking_start_time;
				booking_obj['booking_end_time'] = this.mediaId === 0 ? '' : b.booking_end_time;
				booking_obj['prog_name'] = this.mediaId === 0 ? '' : (b.is_radio === true ? b.booking_station[1] : b.prog_name); 
				booking_obj['contract_ref'] = this.mediaId === 0 ? '' : b.contract_ref;
				booking_obj['network_code'] = this.mediaId === 0 ? '' : b.network_code;
				booking_obj['booking_duration'] = this.mediaId === 0 ? 0 : b.booking_duration;
				booking_obj['mat_deadline'] = b.deadline[0] && b.deadline[0].length !== 0 ? b.deadline[0] : null;
				if (b.is_radio === true && b.station) {
					booking_obj['station_id'] = b.station.id;
				}
				
				bookings.push(booking_obj);
			});

			params['bookings'] = bookings;

			return params
		},
		_calculateBookingAmount(booking, is_commission_amount=false) {
			const new_booking = JSON.parse(JSON.stringify(booking));

			/** supplier, supplier[0] -> supplier_rate, supplier[1] -> supplier_amount */
			const units = Decimal(new_booking.units);
			const supplier_rate = Decimal(new_booking.supplier[0]);
			const supplier_amount = supplier_rate.times(units).toDecimalPlaces(Decimal_Places);
			new_booking.supplier[1] = supplier_amount.toFixed(2);

			/** commission, commission[0] -> commission_amount, commission[1] -> commission_rate */
			let commission_amount = 0;
			let commission_rate = 0;

			if (is_commission_amount) {
				commission_amount = Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);
				commission_rate = supplier_amount.equals(0) ? new Decimal(0) : commission_amount.div(supplier_amount).times(100).toDecimalPlaces(Decimal_Places);
				new_booking.commission[1] = commission_rate.toFixed(2);
			} else {
				commission_rate = Decimal(new_booking.commission[1]).toDecimalPlaces(Decimal_Places);
				commission_amount = supplier_amount.times(commission_rate).times(0.01).toDecimalPlaces(Decimal_Places);
				new_booking.commission[0] = commission_amount.toFixed(2);
			}

			/** net, net[0] -> net_amount */
			const ex_rate = new Decimal(this.exchange_rate).div(100).toDecimalPlaces(Decimal_Places);
			const ex_rate_cost = new Decimal(this.cost_rate.rate).toDecimalPlaces(Decimal_Places);
			const ex_rate_schedule = new Decimal(this.schedule_rate.rate).toDecimalPlaces(Decimal_Places);

			const supplier_amount_sys = supplier_amount.div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
			const commission_amount_sys = commission_amount.div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
			const net_amount_sys = supplier_amount_sys.minus(commission_amount_sys).toDecimalPlaces(Decimal_Places);

			const net_amount_schedule = net_amount_sys.times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
			const margin_amount_sys = net_amount_sys.times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
			const margin_amount_schedule = margin_amount_sys.times(ex_rate).toDecimalPlaces(Decimal_Places);

			const net_schedule = net_amount_schedule.plus(margin_amount_schedule).toDecimalPlaces(Decimal_Places);
			new_booking.net = [net_schedule.toFixed(2)];
			
			/** markup */
			if (new_booking.foc === true) {
				new_booking.markup = ['0.00', '0.00'];
				new_booking.bill = ['0.00'];
				new_booking.revenue = ['0.00'];
			} else {
				let make_up_amount = 0;
				let make_up_perc = 0;
				let rebate = 0;
				
				const mode = new_booking.mode.value;

				if (mode === 0) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markup_perc).toDecimalPlaces(Decimal_Places) : current_markup_perc;
					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 1) {					
					make_up_amount = this.cost_currency.id === this.schedule_currency.id ? commission_amount : commission_amount.times(ex_rate_schedule).div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 2) {
					const supplier_amount_tmp = this.cost_currency.id === this.schedule_currency.id 
						? supplier_amount 
						: supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const commission_amount_tmp = this.cost_currency.id === this.schedule_currency.id 
						? commission_amount 
						: commission_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) 
						? new Decimal(this.rebate_perc).toDecimalPlaces(Decimal_Places) 
						: current_markup_perc;
					make_up_amount = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);

					rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
					make_up_amount = commission_amount_tmp.minus(rebate).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 3) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markup_perc).toDecimalPlaces(Decimal_Places) : current_markup_perc;

					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).plus(commission_amount).toDecimalPlaces(Decimal_Places);
				}
				
				new_booking.markup = [mode === 2 ? rebate.toFixed(2) : make_up_amount.toFixed(2), make_up_perc.toFixed(2)];
				
				/** bill to client */
				const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				const net_from_two_digital = Number(net_from_field.toFixed(2));
				const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

				const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
				new_booking.bill = [bill_two_digital.toFixed(2)];

				/** revenue */
				const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
				new_booking.revenue = [revenue.toFixed(2)];
			}
			
			return new_booking;
		},
		_calculateBookingNet(booking) {
			const new_booking = JSON.parse(JSON.stringify(booking));

			/** supplier, supplier[0] -> supplier_rate, supplier[1] -> supplier_amount */
			const units = Decimal(new_booking.units);
			const supplier_rate = Decimal(new_booking.supplier[0]);
			const supplier_amount = supplier_rate.times(units).toDecimalPlaces(Decimal_Places);

			/** commission, commission[0] -> commission_amount, commission[1] -> commission_rate */
			const commission_amount = Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);

			/** net, net[0] -> net_amount */
			const ex_rate = new Decimal(this.exchange_rate).div(100).toDecimalPlaces(Decimal_Places);
			const ex_rate_cost = new Decimal(this.cost_rate.rate).toDecimalPlaces(Decimal_Places);
			const ex_rate_schedule = new Decimal(this.schedule_rate.rate).toDecimalPlaces(Decimal_Places);

			const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
			const net_sys = new Decimal(net_schedule).div(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
			const net_cost = net_sys.times(ex_rate_cost).toDecimalPlaces(Decimal_Places);

			const margin_cost = supplier_amount.minus(commission_amount).times(ex_rate).toDecimalPlaces(Decimal_Places);
			const commission_amount_cost = supplier_amount.minus(net_cost).plus(margin_cost).toDecimalPlaces(Decimal_Places);
			new_booking.commission[0] = commission_amount_cost.toFixed(2);

			if (supplier_amount.equals(0)) {
				const commission_rate_cost = 0;
				new_booking.commission[1] = Number(commission_rate_cost).toFixed(2);
			} else {
				const commission_rate_cost = supplier_amount.minus(net_cost).div(supplier_amount).times(100).toDecimalPlaces(Decimal_Places);
				new_booking.commission[1] = Number(commission_rate_cost).toFixed(2);
			}

			/** markup */
			if (new_booking.foc === true) {
				new_booking.markup = ['0.00', '0.00'];
				new_booking.bill = ['0.00'];
				new_booking.revenue = ['0.00'];
			} else {
				let make_up_amount = 0;
				let make_up_perc = 0;
				let rebate = 0;
				
				const mode = new_booking.mode.value;

				if (mode === 0) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markup_perc).toDecimalPlaces(Decimal_Places) : current_markup_perc;
					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 1) {					
					make_up_amount = this.cost_currency.id === this.schedule_currency.id 
						? commission_amount_cost 
						: commission_amount_cost.times(ex_rate_schedule).div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 2) {
					const supplier_amount_tmp = this.cost_currency.id === this.schedule_currency.id 
						? supplier_amount 
						: supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const commission_amount_tmp = this.cost_currency.id === this.schedule_currency.id 
						? commission_amount_cost 
						: commission_amount_cost.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) 
						? new Decimal(this.rebate_perc).toDecimalPlaces(Decimal_Places) 
						: current_markup_perc;

					rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
					make_up_amount = commission_amount_tmp.minus(rebate).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 3) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markup_perc).toDecimalPlaces(Decimal_Places) : current_markup_perc;

					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).plus(commission_amount_cost).toDecimalPlaces(Decimal_Places);
				}
				
				new_booking.markup = [mode === 2 ? rebate.toFixed(2) : make_up_amount.toFixed(2), make_up_perc.toFixed(2)];

				/** bill to client */
				const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				const net_from_two_digital = Number(net_from_field.toFixed(2));
				const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

				const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
				new_booking.bill = [bill_two_digital.toFixed(2)];

				/** revenue */
				const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
				new_booking.revenue = [revenue.toFixed(2)];
			}
			
			return new_booking;
		},
		_calculateBookingFOC(booking) {
			const new_booking = JSON.parse(JSON.stringify(booking));

			/** markup, bill to client */
			if (new_booking.foc === true) {
				new_booking.markup = ['0.00', '0.00'];
				new_booking.bill = ['0.00'];
				new_booking.revenue = ['0.00'];
			} else {
				const units = Decimal(new_booking.units);
				const supplier_rate = Decimal(new_booking.supplier[0]);
				const supplier_amount = supplier_rate.times(units).toDecimalPlaces(Decimal_Places);
				const commission_amount = Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);

				const ex_rate_cost = new Decimal(this.cost_rate.rate).toDecimalPlaces(Decimal_Places);
				const ex_rate_schedule = new Decimal(this.schedule_rate.rate).toDecimalPlaces(Decimal_Places);
			
				let make_up_amount = 0;
				let make_up_perc = 0;
				let rebate = 0;
				
				const mode = new_booking.mode.value;

				if (mode === 0) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markup_perc).toDecimalPlaces(Decimal_Places) : current_markup_perc;
					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 1) {					
					make_up_amount = this.cost_currency.id === this.schedule_currency.id ? commission_amount : commission_amount.times(ex_rate_schedule).div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 2) {
					const supplier_amount_tmp = this.cost_currency.id === this.schedule_currency.id 
						? supplier_amount 
						: supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const commission_amount_tmp = this.cost_currency.id === this.schedule_currency.id 
						? commission_amount 
						: commission_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) 
						? new Decimal(this.rebate_perc).toDecimalPlaces(Decimal_Places) 
						: current_markup_perc;
					make_up_amount = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);

					rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
					make_up_amount = commission_amount_tmp.minus(rebate).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 3) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markup_perc).toDecimalPlaces(Decimal_Places) : current_markup_perc;

					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).plus(commission_amount).toDecimalPlaces(Decimal_Places);
				}
				
				new_booking.markup = [mode === 2 ? rebate.toFixed(2) : make_up_amount.toFixed(2), make_up_perc.toFixed(2)];
				
				/** bill to client */
				const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				const net_from_two_digital = Number(net_from_field.toFixed(2));
				const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

				const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
				new_booking.bill = [bill_two_digital.toFixed(2)];

				/** revenue */
				const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
				new_booking.revenue = [revenue.toFixed(2)];
			}

			return new_booking;
		},
		_calculateBookingMode(booking) {
			const new_booking = JSON.parse(JSON.stringify(booking));

			const units = Decimal(new_booking.units);
			const supplier_rate = Decimal(new_booking.supplier[0]);
			const supplier_amount = supplier_rate.times(units).toDecimalPlaces(Decimal_Places);
			const commission_amount = Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);

			const ex_rate_cost = new Decimal(this.cost_rate.rate).toDecimalPlaces(Decimal_Places);
			const ex_rate_schedule = new Decimal(this.schedule_rate.rate).toDecimalPlaces(Decimal_Places);

			let make_up_amount = 0;
			let make_up_perc = 0;
			let rebate = 0;
				
			const mode = new_booking.mode.value;
			if (mode === 0) {
				make_up_perc = new Decimal(this.markup_perc).toDecimalPlaces(Decimal_Places);
				const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				make_up_amount = net_schedule.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
			}
			if (mode === 1) {					
				make_up_amount = this.cost_currency.id === this.schedule_currency.id 
					? commission_amount 
					: commission_amount.times(ex_rate_schedule).div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
			}
			if (mode === 2) {
				const supplier_amount_tmp = this.cost_currency.id === this.schedule_currency.id 
					? supplier_amount
					: supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
					
				const commission_amount_tmp = this.cost_currency.id === this.schedule_currency.id 
					? commission_amount
					: commission_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
					
				make_up_perc = new Decimal(this.rebate_perc).toDecimalPlaces(Decimal_Places);

				rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
				make_up_amount = commission_amount_tmp.minus(rebate).toDecimalPlaces(Decimal_Places);
			}
			if (mode === 3) {
				const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
				make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markup_perc).toDecimalPlaces(Decimal_Places) : current_markup_perc;

				const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				make_up_amount = net_schedule.times(make_up_perc).div(100).plus(commission_amount).toDecimalPlaces(Decimal_Places);
			}
			
			new_booking.markup = [mode === 2 ? rebate.toFixed(2) : make_up_amount.toFixed(2), make_up_perc.toFixed(2)];
			
			/** bill to client */
			const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
			const net_from_two_digital = Number(net_from_field.toFixed(2));
			const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

			const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
			new_booking.bill = [bill_two_digital.toFixed(2)];

			/** revenue */
			const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
			new_booking.revenue = [revenue.toFixed(2)];

			return new_booking;
		},
		_calculateBaseMode(booking, is_markup_amount, is_markup_rate, is_bill) {
			/** calculate markup_amount, markup_rate, bill and revenue */
			const new_booking = JSON.parse(JSON.stringify(booking));

			const mode = new_booking.mode.value;
			if (mode === 0) {
				const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);

				if (is_markup_amount) {
					const make_up_amount = new Decimal(new_booking.markup[0]).toDecimalPlaces(Decimal_Places);
					const make_up_perc = net_schedule.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : make_up_amount.div(net_schedule).times(100).toDecimalPlaces(Decimal_Places);
					new_booking.markup[1] = make_up_perc.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

					const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];

					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_markup_rate) {
					const make_up_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					const make_up_amount = net_schedule.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
					new_booking.markup[0] = make_up_amount.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

					const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];

					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_bill) {
					const units = Decimal(new_booking.units);
					const markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					const commission_perc = new Decimal(new_booking.commission[1]).toDecimalPlaces(Decimal_Places);
					const ex_rate_cost = new Decimal(this.cost_rate.rate).toDecimalPlaces(Decimal_Places);
					const ex_rate_schedule = new Decimal(this.schedule_rate.rate).toDecimalPlaces(Decimal_Places);

					let lvmarkDown = new Decimal(0).toDecimalPlaces(Decimal_Places);
					if (!markup_perc.equals(0)) {
						const lvmarkDown_tmp = this.markdownFromMarkup(markup_perc.toNumber(), Decimal_Places);
						lvmarkDown = new Decimal(lvmarkDown_tmp).toDecimalPlaces(Decimal_Places);
					}

					const bill = new Decimal(new_booking.bill[0]).toDecimalPlaces(Decimal_Places);
					const make_up_amount = bill.times(lvmarkDown).div(100).toDecimalPlaces(Decimal_Places);
					new_booking.markup[0] = make_up_amount.toFixed(2);

					const net_amount = bill.minus(make_up_amount).toDecimalPlaces(Decimal_Places);
					new_booking.net = [net_amount.toFixed(2)];

					const revenue = bill.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : bill.minus(net_amount).div(bill).times(100).toDecimalPlaces(Decimal_Places);
					new_booking.revenue = [revenue.toFixed(2)];

					let lvMarkUp = new Decimal(0).toDecimalPlaces(Decimal_Places);
					if (!commission_perc.equals(0)) {
						const lvMarkUp_tmp = this.markupFromMarkdown(commission_perc.toNumber(), Decimal_Places);
						lvMarkUp = new Decimal(lvMarkUp_tmp).toDecimalPlaces(Decimal_Places);
					}
					const net_amount_tmp = this.cost_currency.id === this.schedule_currency.id ? net_amount : net_amount.div(ex_rate_schedule).times(ex_rate_cost).toDecimalPlaces(Decimal_Places);
					const commission_amount_fc = net_amount_tmp.times(lvMarkUp).div(100).toDecimalPlaces(Decimal_Places);
					new_booking.commission[0] = commission_amount_fc.toFixed(2);

					const supplier_amount = net_amount_tmp.plus(commission_amount_fc).toDecimalPlaces(Decimal_Places);
					new_booking.supplier[1] = supplier_amount.toFixed(2);					

					const supplier_rate = supplier_amount.div(units).toDecimalPlaces(Decimal_Places);
					new_booking.supplier[0] = supplier_rate.toFixed(2);
				}
			}
			if (mode === 2) {
				const supplier_amount = new Decimal(new_booking.supplier[1]).toDecimalPlaces(Decimal_Places);
				const ex_rate_cost = new Decimal(this.cost_rate.rate).toDecimalPlaces(Decimal_Places);
				const ex_rate_schedule = new Decimal(this.schedule_rate.rate).toDecimalPlaces(Decimal_Places);
				const supplier_amount_tmp = this.cost_currency.id === this.schedule_currency.id ? supplier_amount : supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
				
				if (is_markup_amount) {
					const rebate = new Decimal(new_booking.markup[0]).toDecimalPlaces(Decimal_Places);
					const make_up_perc = supplier_amount_tmp.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : rebate.div(supplier_amount_tmp).times(100).toDecimalPlaces(Decimal_Places);
					new_booking.markup[1] = make_up_perc.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const commission_amount_from_field = new Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);
					const make_up_amount_from_field = new Decimal(new_booking.markup[0]).toDecimalPlaces(Decimal_Places);

					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const commission_amount_two_digital = Number(commission_amount_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount_from_field.toFixed(2));

					const bill_two_digital = net_from_two_digital + commission_amount_two_digital - make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];
				
					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_markup_rate) {
					const make_up_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					const rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
					new_booking.markup[0] = rebate.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const commission_amount_from_field = new Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);
					const make_up_amount_from_field = new Decimal(new_booking.markup[0]).toDecimalPlaces(Decimal_Places);
					
					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const commission_amount_two_digital = Number(commission_amount_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount_from_field.toFixed(2));

					const bill_two_digital = net_from_two_digital + commission_amount_two_digital - make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];

					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_bill) {
					const units = Decimal(new_booking.units);
					const markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					const commission_perc = new Decimal(new_booking.commission[1]).toDecimalPlaces(Decimal_Places);

					const bill = new Decimal(new_booking.bill[0]);
					const supplier_amount_div = bill.div(100 - markup_perc).times(100).toDecimalPlaces(2);
					const commission_amount_div = supplier_amount_div.times(commission_perc).div(100).toDecimalPlaces(2);

					const net_amount = supplier_amount_div.minus(commission_amount_div).toDecimalPlaces(Decimal_Places);
					const rebate = bill.minus(net_amount).toDecimalPlaces(Decimal_Places);
					const markup_amount = rebate.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : commission_amount_div.minus(rebate).toDecimalPlaces(Decimal_Places);
					const revenue = bill.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : bill.minus(net_amount).div(bill).times(100).toDecimalPlaces(Decimal_Places);
					
					const supplier_amount = this.cost_currency.id === this.schedule_currency.id 
						? supplier_amount_div
						: supplier_amount_div.div(ex_rate_schedule).times(ex_rate_cost).toDecimalPlaces(Decimal_Places);
					const supplier_rate = supplier_amount.div(units).toDecimalPlaces(Decimal_Places);
					const commission_amount = supplier_amount.times(commission_perc).div(100).toDecimalPlaces(Decimal_Places);

					new_booking.supplier[0] = supplier_rate.toFixed(2);
					new_booking.supplier[1] = supplier_amount.toFixed(2);
					new_booking.commission[0] = commission_amount.toFixed(2);
					new_booking.net = [net_amount.toFixed(2)];
					new_booking.markup[0] = markup_amount.toFixed(2);
					new_booking.revenue = [revenue.toFixed(2)];
				}
			}
			if (mode === 3) {
				const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				const commission_amount = new Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);

				if (is_markup_amount) {
					const make_up_amount = new Decimal(new_booking.markup[0]).toDecimalPlaces(Decimal_Places);
					const make_up_perc = net_schedule.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : make_up_amount.minus(commission_amount).times(100).div(net_schedule);
					new_booking.markup[1] = make_up_perc.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

					const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];

					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_markup_rate) {
					const make_up_perc = new Decimal(new_booking.markup[1]).div(100).toDecimalPlaces(Decimal_Places);
					const make_up_amount = net_schedule.times(make_up_perc).plus(commission_amount).toDecimalPlaces(Decimal_Places);
					new_booking.markup[0] = make_up_amount.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

					const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];

					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_bill) {
					const bill = new Decimal(new_booking.bill[0]).toDecimalPlaces(Decimal_Places);

					const make_up_amount = net_schedule.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : bill.minus(net_schedule).toDecimalPlaces(Decimal_Places);
					const make_up_perc = net_schedule.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : make_up_amount.minus(commission_amount).times(100).div(net_schedule);
					new_booking.markup = [make_up_amount.toFixed(2), make_up_perc.toFixed(2)];

					const revenue = bill.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : bill.minus(net_schedule).div(bill).times(100).toDecimalPlaces(Decimal_Places);
					new_booking.revenue = [revenue.toFixed(2)];
				}
			}

			return new_booking;
		},
		_getNewIndex() {
			const index_all = this.booking_list.map(b => { return Number((b.index.split('_'))[1]) });
			index_all.sort();
			const new_index = index_all.length === 0 ? '0_0': `0_${index_all[index_all.length - 1] + 1}`;
			return new_index;
		},
		markdownFromMarkup(pvMarkup, pvRounding=2) {
			let markdown = 0;

			const rnd = new Decimal(pvMarkup).toDecimalPlaces(2);

			if (rnd.equals(-100)) {
				markdown = 0.00;
			} else {
				const pvMarkup_new = 100.0 - (10000.00 / (100.00 + pvMarkup ));
				markdown = new Decimal(pvMarkup_new).toDecimalPlaces(pvRounding);
			}
			
			return markdown.toNumber();
		},
		markupFromMarkdown(pvMarkdown, pvRounding=2) {
			let markup = 0;

			const rnd = new Decimal(pvMarkdown).toDecimalPlaces(2);

			if (rnd.equals(100)) {
				markup = 0.00;
			} else {
				const pvMarkdown_new = (10000.00 / (100 - pvMarkdown)) - 100.0;
				markup = new Decimal(pvMarkdown_new).toDecimalPlaces(pvRounding);
			}

			return markup.toNumber();
		}
	}
}
</script>

<style lang="scss" scoped>
.title-sytle {
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
}
.selector-item-style {
	color: #605AF6;
}
.background-color {
	background-color: #E8EAEC;
}
.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 12px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
.font-normal-style {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 36px;
	letter-spacing: 0.5px;
	vertical-align: middle;
}
.font-bold-style {
	font-family: Roboto;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	letter-spacing: 0.5px;
	vertical-align: middle;
}
.font-over-long {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.text-style {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 36px;
	letter-spacing: 0.5px;
	text-align: center;
	vertical-align: middle;
}
.text-nomal-color {
	color: rgba(25, 42, 62, 0.7);
}
.text-nomal-disable-color {
	color: rgba(25, 42, 62, 0.3);
}
.header-background-color {
	background-color: #EAEAEA;
}
.font-header-style {
	color: #192A3E;
}
.reversal-text-color {
	color: #F45252;
}
.disable-btn.v-btn--disabled {
  /* Re-enable pointer events so the cursor style can be applied */
  pointer-events: auto !important;
  /* Set the desired cursor style */
  cursor: not-allowed !important; 
}

.dialog-container {
	background: #FFFFFF;
  border-radius: 4px;
}
.event-btn {
  display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
  align-items: center;
}
.top-line {
  width: 100%;
  height: 4px;
  background: #81CC00;
  border-radius: 4px 4px 0px 0px;
}
.task-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #81CC00;
}
.button-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  letter-spacing: 0.5px;
}
.button-text-current {
  color: #609800;
}
.fixedToolbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
}

::v-deep {
	.select-field.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
		min-height: 36px;
		max-width: 400px;
	}
	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding-right: 4px;
    padding-left: 4px;
  }
	.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    padding-left: 0;
		padding-right: 0;
	}
  .select-in-cell.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 32px;
  }
	.select-exchange.v-text-field .v-input__control .v-input__slot {
		min-height: auto !important;
		display: flex !important;
		align-items: center !important;
	}
  .field-in-cell.v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
		padding: 0;
  }
	.field-in-cell input {
		padding-right: 4px;
		text-align: end;
	}
	.reversal-text-color input {
		color:#F45252;
	}
  .field-in-cell.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
    margin-top: 0;
    margin-right: 4px;
  }
  .field-in-top.theme--light.v-input input {
    color: #605AF6;
  }
	.reversal-row {
		background-color: #FFF1F1 !important;
	}
	.date-in-cell.v-text-field fieldset, .v-text-field .v-input__control{
    font-family: Roboto;
		font-weight: 400;
		font-size: 14px;
		line-height: 36px;
		letter-spacing: 0.5px;
  }
}
</style>